(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2775],{

/***/ 80412:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"scrollWrapper":"scrollWrapper--4f40c","selectedCategory":"selectedCategory--12c69","hideEmptyItem":"hideEmptyItem--95a85","badgeList":"badgeList--962d8","hideSelectedCategory":"hideSelectedCategory--1b91f"};

/***/ }),

/***/ 69601:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"var-lg":"1024px","varLg":"1024px","layoutFooter":"layoutFooter--70816","linkingFooter":"linkingFooter--94d58","linkingFooter__title":"linkingFooter__title--49adc","linkingFooterTitle":"linkingFooter__title--49adc","corporativeLinks":"corporativeLinks--cf415","toolsLinks":"toolsLinks--719e5","utilsLinks":"utilsLinks--df6a3","appsAndSocialLinks":"appsAndSocialLinks--294fd","appsAndSocialLinks__description":"appsAndSocialLinks__description--51d1d","appsAndSocialLinksDescription":"appsAndSocialLinks__description--51d1d","appsAndSocialLinks__image":"appsAndSocialLinks__image--cb549","appsAndSocialLinksImage":"appsAndSocialLinks__image--cb549","appsAndSocialLinks__list":"appsAndSocialLinks__list--f0d51","appsAndSocialLinksList":"appsAndSocialLinks__list--f0d51","appsAndSocialLinks__item":"appsAndSocialLinks__item--82b59","appsAndSocialLinksItem":"appsAndSocialLinks__item--82b59","countrySelector__wrapper":"countrySelector__wrapper--524e2","countrySelectorWrapper":"countrySelector__wrapper--524e2","countrySelector__dropdown":"countrySelector__dropdown--c06b6","countrySelectorDropdown":"countrySelector__dropdown--c06b6","countrySelector__flag":"countrySelector__flag--d1d47","countrySelectorFlag":"countrySelector__flag--d1d47","countrySelector__icon":"countrySelector__icon--9d58a","countrySelectorIcon":"countrySelector__icon--9d58a","copyrightFooter":"copyrightFooter--284eb","countrySelectorModal":"countrySelectorModal--7ad41","countrySelectorModal__header":"countrySelectorModal__header--d73d3","countrySelectorModalHeader":"countrySelectorModal__header--d73d3","countrySelectorModal__title":"countrySelectorModal__title--47b64","countrySelectorModalTitle":"countrySelectorModal__title--47b64","countrySelectorModal__subtitle":"countrySelectorModal__subtitle--dabb6","countrySelectorModalSubtitle":"countrySelectorModal__subtitle--dabb6","countrySelectorModal__body":"countrySelectorModal__body--0ad1c","countrySelectorModalBody":"countrySelectorModal__body--0ad1c","countrySelectorModal__closeIcon":"countrySelectorModal__closeIcon--30152","countrySelectorModalCloseIcon":"countrySelectorModal__closeIcon--30152","countrySelectorModal__content":"countrySelectorModal__content--1084a","countrySelectorModalContent":"countrySelectorModal__content--1084a","countrySelectorModalList":"countrySelectorModalList--8915b","countrySelectorModalList__item":"countrySelectorModalList__item--e5e9a","countrySelectorModalListItem":"countrySelectorModalList__item--e5e9a","countrySelectorModalList__flag":"countrySelectorModalList__flag--cd816","countrySelectorModalListFlag":"countrySelectorModalList__flag--cd816","modal":"modal--43909","modal__content":"modal__content--2876f","modalContent":"modal__content--2876f","showModal":"showModal--fb5f3","modal__overlay":"modal__overlay--13690","modalOverlay":"modal__overlay--13690","showBackdrop":"showBackdrop--f34af"};

/***/ }),

/***/ 38325:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"var-lg":"1024px","varLg":"1024px","var-xxl":"1360px","varXxl":"1360px","svgIcon":"svgIcon--cbbb7","layoutHeader":"layoutHeader--0c2b1","layoutHeader__hamburger":"layoutHeader__hamburger--072c0","layoutHeaderHamburger":"layoutHeader__hamburger--072c0","layoutHeader__authNoLoggedAreaMobile":"layoutHeader__authNoLoggedAreaMobile--48091","layoutHeaderAuthNoLoggedAreaMobile":"layoutHeader__authNoLoggedAreaMobile--48091","layoutHeader__authArea":"layoutHeader__authArea--a90ac","layoutHeaderAuthArea":"layoutHeader__authArea--a90ac","layoutHeader__nav":"layoutHeader__nav--74962","layoutHeaderNav":"layoutHeader__nav--74962","layoutHeader__overlay":"layoutHeader__overlay--c1176","layoutHeaderOverlay":"layoutHeader__overlay--c1176","layoutHeader__vendorAuth":"layoutHeader__vendorAuth--3b108","layoutHeaderVendorAuth":"layoutHeader__vendorAuth--3b108","layoutHeader__logoAnchor":"layoutHeader__logoAnchor--863ee","layoutHeaderLogoAnchor":"layoutHeader__logoAnchor--863ee","layoutHeader__navOpen":"layoutHeader__navOpen--adece","layoutHeaderNavOpen":"layoutHeader__navOpen--adece","openNav":"openNav--2be51","showOverlay":"showOverlay--7cd10","layoutHeader__authNoLoggedArea":"layoutHeader__authNoLoggedArea--74272","layoutHeaderAuthNoLoggedArea":"layoutHeader__authNoLoggedArea--74272","layoutHeader__vendorAuthIcon":"layoutHeader__vendorAuthIcon--52490","layoutHeaderVendorAuthIcon":"layoutHeader__vendorAuthIcon--52490","visible":"visible--e4f45","layoutNavMenu":"layoutNavMenu--b7bdb","layoutNavMenu__item":"layoutNavMenu__item--05f63","layoutNavMenuItem":"layoutNavMenu__item--05f63","layoutNavMenu__item--mutableDesktop":"layoutNavMenu__item--mutableDesktop--05a1d","layoutNavMenuItemMutableDesktop":"layoutNavMenu__item--mutableDesktop--05a1d","layoutNavMenu__item--mutableTablet":"layoutNavMenu__item--mutableTablet--68015","layoutNavMenuItemMutableTablet":"layoutNavMenu__item--mutableTablet--68015","layoutNavMenu__itemFooter":"layoutNavMenu__itemFooter--406ae","layoutNavMenuItemFooter":"layoutNavMenu__itemFooter--406ae","layoutNavMenu__itemFooter--bordered":"layoutNavMenu__itemFooter--bordered--d3995","layoutNavMenuItemFooterBordered":"layoutNavMenu__itemFooter--bordered--d3995","layoutNavMenu__itemFooter--colored":"layoutNavMenu__itemFooter--colored--23202","layoutNavMenuItemFooterColored":"layoutNavMenu__itemFooter--colored--23202","layoutNavMenu__anchorFooter":"layoutNavMenu__anchorFooter--81745","layoutNavMenuAnchorFooter":"layoutNavMenu__anchorFooter--81745","layoutNavMenu__itemClose":"layoutNavMenu__itemClose--501c4","layoutNavMenuItemClose":"layoutNavMenu__itemClose--501c4","layoutNavMenu__header":"layoutNavMenu__header--a70ff","layoutNavMenuHeader":"layoutNavMenu__header--a70ff","layoutNavMenu__anchor":"layoutNavMenu__anchor--4be81","layoutNavMenuAnchor":"layoutNavMenu__anchor--4be81","layoutNavMenu__openArea":"layoutNavMenu__openArea--02d14","layoutNavMenuOpenArea":"layoutNavMenu__openArea--02d14","layoutNavMenu__anchorArrow":"layoutNavMenu__anchorArrow--8c521","layoutNavMenuAnchorArrow":"layoutNavMenu__anchorArrow--8c521","hover":"hover--5b97b","sidebarNavMenuOpened":"sidebarNavMenuOpened--0f949","layoutNavMenuTab":"layoutNavMenuTab--7d435","layoutNavMenuTab__header":"layoutNavMenuTab__header--b3559","layoutNavMenuTabHeader":"layoutNavMenuTab__header--b3559","layoutNavMenuTab__icon":"layoutNavMenuTab__icon--70011","layoutNavMenuTabIcon":"layoutNavMenuTab__icon--70011","layoutNavMenuTab__iconClose":"layoutNavMenuTab__iconClose--477f2","layoutNavMenuTabIconClose":"layoutNavMenuTab__iconClose--477f2","layoutNavMenuTab__title":"layoutNavMenuTab__title--668de","layoutNavMenuTabTitle":"layoutNavMenuTab__title--668de","layoutNavMenuTab__layout":"layoutNavMenuTab__layout--6db57","layoutNavMenuTabLayout":"layoutNavMenuTab__layout--6db57","layoutNavMenuTab--open":"layoutNavMenuTab--open--42875","layoutNavMenuTabOpen":"layoutNavMenuTab--open--42875","open":"open--d6b1f","showNavigatorTab":"showNavigatorTab--f308c","layoutNavMenuTabSubmenu":"layoutNavMenuTabSubmenu--ceea2","layoutNavMenuTabSubmenu__title":"layoutNavMenuTabSubmenu__title--0e0d0","layoutNavMenuTabSubmenuTitle":"layoutNavMenuTabSubmenu__title--0e0d0","layoutNavMenuTabSubmenuList":"layoutNavMenuTabSubmenuList--fef40","layoutNavMenuTabSubmenuList__item":"layoutNavMenuTabSubmenuList__item--5208f","layoutNavMenuTabSubmenuListItem":"layoutNavMenuTabSubmenuList__item--5208f","layoutNavMenuTabSubmenuList__item--viewAll":"layoutNavMenuTabSubmenuList__item--viewAll--f75af","layoutNavMenuTabSubmenuListItemViewAll":"layoutNavMenuTabSubmenuList__item--viewAll--f75af","layoutNavMenuTabSubmenuList__item--primary":"layoutNavMenuTabSubmenuList__item--primary--d13fb","layoutNavMenuTabSubmenuListItemPrimary":"layoutNavMenuTabSubmenuList__item--primary--d13fb","layoutNavMenuTabSubmenuList__content":"layoutNavMenuTabSubmenuList__content--be897","layoutNavMenuTabSubmenuListContent":"layoutNavMenuTabSubmenuList__content--be897","layoutNavMenuTabSubmenuList__itemIcon":"layoutNavMenuTabSubmenuList__itemIcon--bdc8e","layoutNavMenuTabSubmenuListItemIcon":"layoutNavMenuTabSubmenuList__itemIcon--bdc8e","layoutNavMenuTabSubmenuBanners":"layoutNavMenuTabSubmenuBanners--ddb95","layoutNavMenuAuthLogged":"layoutNavMenuAuthLogged--16404","layoutNavMenuAuthLogged__avatar":"layoutNavMenuAuthLogged__avatar--bfa73","layoutNavMenuAuthLoggedAvatar":"layoutNavMenuAuthLogged__avatar--bfa73","layoutNavMenuAuthLogged__avatarContainer":"layoutNavMenuAuthLogged__avatarContainer--6c8c0","layoutNavMenuAuthLoggedAvatarContainer":"layoutNavMenuAuthLogged__avatarContainer--6c8c0","layoutNavMenuAuthLogged__item":"layoutNavMenuAuthLogged__item--b4790","layoutNavMenuAuthLoggedItem":"layoutNavMenuAuthLogged__item--b4790","layoutNavMenuAuthLogged__itemAnchor":"layoutNavMenuAuthLogged__itemAnchor--b768d","layoutNavMenuAuthLoggedItemAnchor":"layoutNavMenuAuthLogged__itemAnchor--b768d","layoutNavMenuAuthLogged__itemFavoriteIcon":"layoutNavMenuAuthLogged__itemFavoriteIcon--57607","layoutNavMenuAuthLoggedItemFavoriteIcon":"layoutNavMenuAuthLogged__itemFavoriteIcon--57607","layoutNavMenuAuthLoggedInbox":"layoutNavMenuAuthLoggedInbox--815e3","layoutNavMenuAuthLoggedInbox__icon":"layoutNavMenuAuthLoggedInbox__icon--ae6c7","layoutNavMenuAuthLoggedInboxIcon":"layoutNavMenuAuthLoggedInbox__icon--ae6c7","layoutNavMenuAuthLoggedInbox__counter":"layoutNavMenuAuthLoggedInbox__counter--b785a","layoutNavMenuAuthLoggedInboxCounter":"layoutNavMenuAuthLoggedInbox__counter--b785a","layoutNavMenuAuthLoggedInbox__number":"layoutNavMenuAuthLoggedInbox__number--d4bc4","layoutNavMenuAuthLoggedInboxNumber":"layoutNavMenuAuthLoggedInbox__number--d4bc4","layoutNavMenuAuth":"layoutNavMenuAuth--8a589","layoutNavMenuAuth__item":"layoutNavMenuAuth__item--b35c1","layoutNavMenuAuthItem":"layoutNavMenuAuth__item--b35c1","layoutNavMenuAuth__anchor":"layoutNavMenuAuth__anchor--79744","layoutNavMenuAuthAnchor":"layoutNavMenuAuth__anchor--79744"};

/***/ }),

/***/ 95241:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapper":"layoutWrapper--e086a"};

/***/ }),

/***/ 66338:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"var-xxl":"1360px","varXxl":"1360px","varSpUp2":"1.5rem","varSpUp4":"2rem","varSpDown2":"0.5rem","varSpBase":"1rem","container":"container--1e90a","container__ww":"container__ww--bad5e","containerWw":"container__ww--bad5e","body":"body--67251","noticeBannerOverrides":"noticeBannerOverrides--d0369"};

/***/ }),

/***/ 75401:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"var-md":"768px","varMd":"768px","scrollToTop":"scrollToTop--1d59f","isActive":"isActive--e4158","arrow":"arrow--de903"};

/***/ }),

/***/ 84128:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageSubtitleFreeSampleContainer":"pageSubtitleFreeSampleContainer--489a7","categoryHeader":"categoryHeader--aec76","freeSampleContainer":"freeSampleContainer--f5212"};

/***/ }),

/***/ 82029:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"noticeBanner":"noticeBanner--b3cab"};

/***/ }),

/***/ 19237:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"var-lg":"1024px","varLg":"1024px","var-xs-max":"479.98px","varXsMax":"479.98px","banner":"banner--f257a","color-ac007c":"color-ac007c--83d28","colorAc007c":"color-ac007c--83d28","color-d700a0":"color-d700a0--f065f","colorD700a0":"color-d700a0--f065f","color-ff44cb":"color-ff44cb--f5a42","colorFf44cb":"color-ff44cb--f5a42","color-febbf7":"color-febbf7--13bca","colorFebbf7":"color-febbf7--13bca","color-ffe4fb":"color-ffe4fb--3c7e7","colorFfe4fb":"color-ffe4fb--3c7e7","color-000000":"color-000000--d3364","color000000":"color-000000--d3364","color-37393f":"color-37393f--0448a","color37393f":"color-37393f--0448a","color-51545c":"color-51545c--80363","color51545c":"color-51545c--80363","color-9699a0":"color-9699a0--e9fea","color9699a0":"color-9699a0--e9fea","color-caccd0":"color-caccd0--7c39b","colorCaccd0":"color-caccd0--7c39b","color-e4e5e9":"color-e4e5e9--4d71e","colorE4e5e9":"color-e4e5e9--4d71e","color-f1f2f4":"color-f1f2f4--c2a23","colorF1f2f4":"color-f1f2f4--c2a23","color-ffffff":"color-ffffff--c2dd3","colorFfffff":"color-ffffff--c2dd3","color-364c9d":"color-364c9d--3c4e2","color364c9d":"color-364c9d--3c4e2","color-0073e6":"color-0073e6--6c544","color0073e6":"color-0073e6--6c544","color-a1cdf5":"color-a1cdf5--a08f3","colorA1cdf5":"color-a1cdf5--a08f3","color-c4dff9":"color-c4dff9--bc388","colorC4dff9":"color-c4dff9--bc388","color-e6f2fc":"color-e6f2fc--934ba","colorE6f2fc":"color-e6f2fc--934ba","color-fb8b00":"color-fb8b00--fd42d","colorFb8b00":"color-fb8b00--fd42d","color-fbaf00":"color-fbaf00--52f99","colorFbaf00":"color-fbaf00--52f99","color-fbbb03":"color-fbbb03--bbb5c","colorFbbb03":"color-fbbb03--bbb5c","color-fdde81":"color-fdde81--bb5f2","colorFdde81":"color-fdde81--bb5f2","color-fff7e1":"color-fff7e1--03b0c","colorFff7e1":"color-fff7e1--03b0c","color-db4936":"color-db4936--38578","colorDb4936":"color-db4936--38578","color-fa592d":"color-fa592d--b464d","colorFa592d":"color-fa592d--b464d","color-ff6e00":"color-ff6e00--1cea1","colorFf6e00":"color-ff6e00--1cea1","color-ff9357":"color-ff9357--b5bfb","colorFf9357":"color-ff9357--b5bfb","color-ffd1bd":"color-ffd1bd--97355","colorFfd1bd":"color-ffd1bd--97355","color-ad9587":"color-ad9587--e114c","colorAd9587":"color-ad9587--e114c","color-c7afa1":"color-c7afa1--8b6dd","colorC7afa1":"color-c7afa1--8b6dd","color-e8d5ca":"color-e8d5ca--93d0d","colorE8d5ca":"color-e8d5ca--93d0d","color-f7e6dc":"color-f7e6dc--150aa","colorF7e6dc":"color-f7e6dc--150aa","color-fff5ed":"color-fff5ed--f497e","colorFff5ed":"color-fff5ed--f497e","color-114394":"color-114394--d9554","color114394":"color-114394--d9554","color-f4f9ff":"color-f4f9ff--06b0d","colorF4f9ff":"color-f4f9ff--06b0d","color-005a25":"color-005a25--28b10","color005a25":"color-005a25--28b10","color-008a05":"color-008a05--980a9","color008a05":"color-008a05--980a9","color-e2ffee":"color-e2ffee--1443c","colorE2ffee":"color-e2ffee--1443c","color-823300":"color-823300--5bc37","color823300":"color-823300--5bc37","color-c25400":"color-c25400--25ab9","colorC25400":"color-c25400--25ab9","color-fff3dd":"color-fff3dd--228e1","colorFff3dd":"color-fff3dd--228e1","color-a1000b":"color-a1000b--d041b","colorA1000b":"color-a1000b--d041b","color-eb1400":"color-eb1400--2b485","colorEb1400":"color-eb1400--2b485","color-ffece4":"color-ffece4--b5bfc","colorFfece4":"color-ffece4--b5bfc","color-CADAE8":"color-CADAE8--7c719","colorCADAE8":"color-CADAE8--7c719"};

/***/ }),

/***/ 22067:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"var-lg":"1024px","varLg":"1024px","var-xs-max":"479.98px","varXsMax":"479.98px","banner":"banner--44b89","color-088f95":"color-088f95--d7df3","color088f95":"color-088f95--d7df3","color-17abb1":"color-17abb1--0058a","color17abb1":"color-17abb1--0058a","color-19b5bc":"color-19b5bc--bd141","color19b5bc":"color-19b5bc--bd141","color-a3e1e4":"color-a3e1e4--0ce44","colorA3e1e4":"color-a3e1e4--0ce44","color-e9f6f8":"color-e9f6f8--e4d3a","colorE9f6f8":"color-e9f6f8--e4d3a","color-000000":"color-000000--1a8bc","color000000":"color-000000--1a8bc","color-222222":"color-222222--b22bf","color222222":"color-222222--b22bf","color-6c6c6c":"color-6c6c6c--7a29b","color6c6c6c":"color-6c6c6c--7a29b","color-8c8c8c":"color-8c8c8c--87374","color8c8c8c":"color-8c8c8c--87374","color-d9d9d9":"color-d9d9d9--bf671","colorD9d9d9":"color-d9d9d9--bf671","color-efefef":"color-efefef--9b87f","colorEfefef":"color-efefef--9b87f","color-f8f8f8":"color-f8f8f8--5c03d","colorF8f8f8":"color-f8f8f8--5c03d","color-ffffff":"color-ffffff--fff84","colorFfffff":"color-ffffff--fff84","color-3073e4":"color-3073e4--4abb0","color3073e4":"color-3073e4--4abb0","color-588de4":"color-588de4--8449e","color588de4":"color-588de4--8449e","color-6c9dee":"color-6c9dee--a88e7","color6c9dee":"color-6c9dee--a88e7","color-c4d8f8":"color-c4d8f8--3b424","colorC4d8f8":"color-c4d8f8--3b424","color-e9f0fc":"color-e9f0fc--fc3a4","colorE9f0fc":"color-e9f0fc--fc3a4","color-d6341e":"color-d6341e--1f6aa","colorD6341e":"color-d6341e--1f6aa","color-e8604e":"color-e8604e--b0cf8","colorE8604e":"color-e8604e--b0cf8","color-f06f5e":"color-f06f5e--d4ca3","colorF06f5e":"color-f06f5e--d4ca3","color-f9c5bf":"color-f9c5bf--34d19","colorF9c5bf":"color-f9c5bf--34d19","color-fde9e7":"color-fde9e7--7f7e0","colorFde9e7":"color-fde9e7--7f7e0","color-1961d9":"color-1961d9--a790e","color1961d9":"color-1961d9--a790e","color-326935":"color-326935--94a7f","color326935":"color-326935--94a7f","color-48964d":"color-48964d--a349f","color48964d":"color-48964d--a349f","color-e4efe5":"color-e4efe5--98531","colorE4efe5":"color-e4efe5--98531","color-fabb00":"color-fabb00--3aa94","colorFabb00":"color-fabb00--3aa94","color-ffd967":"color-ffd967--4db48","colorFfd967":"color-ffd967--4db48","color-fff7e1":"color-fff7e1--54fa5","colorFff7e1":"color-fff7e1--54fa5","color-a82720":"color-a82720--c082b","colorA82720":"color-a82720--c082b","color-db4c45":"color-db4c45--aa24b","colorDb4c45":"color-db4c45--aa24b","color-f2dede":"color-f2dede--cb969","colorF2dede":"color-f2dede--cb969","color-db4936":"color-db4936--40ee6","colorDb4936":"color-db4936--40ee6","color-f2572c":"color-f2572c--b39c2","colorF2572c":"color-f2572c--b39c2","color-ff6e00":"color-ff6e00--75404","colorFf6e00":"color-ff6e00--75404","color-ff9357":"color-ff9357--0a7c9","colorFf9357":"color-ff9357--0a7c9","color-ffd1bd":"color-ffd1bd--ffd52","colorFfd1bd":"color-ffd1bd--ffd52","color-ad9587":"color-ad9587--b6ff0","colorAd9587":"color-ad9587--b6ff0","color-c7afa1":"color-c7afa1--32eb9","colorC7afa1":"color-c7afa1--32eb9","color-e8d5ca":"color-e8d5ca--29469","colorE8d5ca":"color-e8d5ca--29469","color-f7e6dc":"color-f7e6dc--8d976","colorF7e6dc":"color-f7e6dc--8d976","color-fff5ed":"color-fff5ed--1f9dc","colorFff5ed":"color-fff5ed--1f9dc","color-f1f2f4":"color-f1f2f4--b6089","colorF1f2f4":"color-f1f2f4--b6089"};

/***/ }),

/***/ 30240:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"h1":"h1--cac8b","h2":"h2--440a8","h3":"h3--8b759","h4":"h4--1e3c2","body1":"body1--3fd4e","body2":"body2--d306c","editorial":"editorial--3cae4","heroSmall":"heroSmall--bcc76","heroMedium":"heroMedium--aaa3d"};

/***/ }),

/***/ 28336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useOnScreen; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99084);


function useOnScreen(ref) {
    var rootMargin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "0px";
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isIntersecting = _$ref[0], setIntersecting = _$ref[1];
    var observer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (false) {}
        return new IntersectionObserver(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 1), entry = _param[0];
            return setIntersecting(entry.isIntersecting);
        }, {
            rootMargin: rootMargin
        });
    }, [
        ref,
        rootMargin
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (false) {}
        if (!ref.current) return;
        observer === null || observer === void 0 ? void 0 : observer.observe(ref.current);
        return function() {
            return observer === null || observer === void 0 ? void 0 : observer.disconnect();
        };
    }, [
        ref,
        observer
    ]);
    return  false ? 0 : isIntersecting;
}


/***/ }),

/***/ 71684:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R1": function() { return /* binding */ WebviewLayout; },
  "ZP": function() { return /* binding */ core_components_Layout; }
});

// UNUSED EXPORTS: LayoutWrapper

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72491);
// EXTERNAL MODULE: ./components/Tracking/useTracking/useTracking.tsx
var useTracking = __webpack_require__(14160);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./data/updatedCategoryHierarchyData-ww.tsx
// WW

var saveTheDatesLink = "/save-the-dates";
var changeTheDatesLink = "/change-the-dates";
var invitationsLink = "/invitations";
var ceremonyReceptionLink = "/ceremony-reception";
var thankYousLink = "/thank-yous";
var envelopesLink = "/envelopes";
var saveTheDateCards = {
    sku: "SDC",
    name: "Save the Date Cards",
    seoTags: {
        title: "Save the Date Cards | Free Samples | WeddingWire",
        description: "Save-the-date cards that are easy to customize and make it easy to stick to your budget. Shop your favorite designs and get free save-the-date samples.",
        abstract: "Save-the-date cards that are easy to customize and make it easy to stick to your budget. Shop your favorite designs and get free save-the-date samples.",
        robots: "index, follow"
    },
    href: "/save-the-date-cards",
    parentSku: "STDA"
};
var saveTheDatePostCards = {
    sku: "SDP",
    name: "Save the Date Postcards",
    seoTags: {
        title: "Save The Date Postcards | Easily Customizable Designs | WeddingWire",
        description: "Make your wedding something to remember with custom save-the-date postcards. Shop your favorite save-the-date postcard designs and easily stick to your budget.",
        abstract: "Make your wedding something to remember with custom save-the-date postcards. Shop your favorite save-the-date postcard designs and easily stick to your budget.",
        robots: "index, follow"
    },
    href: "/save-the-date-postcards",
    parentSku: "STDA"
};
var saveTheDates = {
    sku: "STDA",
    name: "Save the Dates",
    seoTags: {
        title: "Wedding Save The Dates | Elegant to Rustic Designs | WeddingWire",
        description: "Announce your wedding with customizable save-the-date cards. With hundreds of styles, from elegant to rustic, you can find one that matches your wedding vision.",
        abstract: "Announce your wedding with customizable save-the-date cards. With hundreds of styles, from elegant to rustic, you can find one that matches your wedding vision.",
        robots: "noindex, nofollow"
    },
    href: saveTheDatesLink,
    subCategories: [
        saveTheDateCards,
        saveTheDatePostCards
    ]
};
var changeTheDateCards = {
    sku: "CDC",
    name: "Change the Date Cards",
    seoTags: {
        title: "Change The Date Wedding Cards | Easily Customizable Designs |  WeddingWire",
        description: "Need to change the date of your wedding? Shop custom change the date cards today. Find your favorite design and easily customize.",
        abstract: "Need to change the date of your wedding? Shop custom change the date cards today. Find your favorite design and easily customize.",
        robots: "index, follow"
    },
    href: "/change-the-date-cards",
    parentSku: "CTDA"
};
var changeTheDatePostCards = {
    sku: "CDP",
    name: "Change the Date Postcards",
    seoTags: {
        title: "Change The Date Wedding Postcards | Easily Customizable Designs | WeddingWire",
        description: "Need to change the date of your wedding? Shop custom change the date postcards today. Find your favorite design and easily customize.",
        abstract: "Need to change the date of your wedding? Shop custom change the date postcards today. Find your favorite design and easily customize.",
        robots: "index, follow"
    },
    href: "/change-the-date-postcards",
    parentSku: "CTDA"
};
var changeTheDates = {
    sku: "CTDA",
    name: "Change the Dates",
    seoTags: {
        title: "Change The Dates | Wedding Postponement Stationery | WeddingWire",
        description: "Change of plans? Update your guests about your wedding postponement in style with affordable, customizable wedding change-the-date cards.",
        abstract: "Change of plans? Update your guests about your wedding postponement in style with affordable, customizable wedding change-the-date cards.",
        robots: "noindex, nofollow"
    },
    href: changeTheDatesLink,
    subCategories: [
        changeTheDateCards,
        changeTheDatePostCards
    ]
};
var weddingInvitations = {
    sku: "WIN",
    name: "Wedding Invitations",
    seoTags: {
        title: "Wedding Invitations | Free Samples | WeddingWire",
        description: "Wedding invitations that are easy to customize and make it easy to stick to your budget. Shop your favorite designs and get free invitation samples.",
        abstract: "Wedding invitations that are easy to customize and make it easy to stick to your budget. Shop your favorite designs and get free invitation samples.",
        robots: "index, follow"
    },
    href: "/wedding-invitations",
    parentSku: "INVI"
};
var rsvpCards = {
    sku: "RSC",
    name: "RSVP Cards",
    seoTags: {
        title: "Wedding RSVP Cards | Easily Customizable Designs | WeddingWire",
        description: "Wedding RSVP cards that are easy to customize and make it easy to stick to your budget. Shop your favorite response card designs with matching invitations.",
        abstract: "Wedding RSVP cards that are easy to customize and make it easy to stick to your budget. Shop your favorite response card designs with matching invitations.",
        robots: "index, follow"
    },
    href: "/wedding-rsvp-cards",
    parentSku: "INVI"
};
var enclosureCards = {
    sku: "ENC",
    name: "Enclosure Cards",
    seoTags: {
        title: "Enclosure Cards | Easily Customizable Designs | WeddingWire",
        description: "Enclosure cards that are easy to customize and make it easy to stick to your budget. Shop your favorite enclosure card designs with matching invitations.",
        abstract: "Enclosure cards that are easy to customize and make it easy to stick to your budget. Shop your favorite enclosure card designs with matching invitations.",
        robots: "index, follow"
    },
    href: "/wedding-enclosure-cards",
    parentSku: "INVI"
};
var envelopeLiners = {
    sku: "EVL",
    name: "Envelope Liners",
    seoTags: {
        title: "Envelope Liners | Easily Customizable Designs | WeddingWire",
        description: "Shop envelope liners for your wedding invitations that showcase your style and fit your budget. Customizing your envelope liners is easy and free.",
        abstract: "Shop envelope liners for your wedding invitations that showcase your style and fit your budget. Customizing your envelope liners is easy and free.",
        robots: "index, follow"
    },
    href: "/wedding-envelope-liners",
    parentSku: "INVI"
};
var bridalShowerInvitations = {
    sku: "BRI",
    name: "Bridal Shower Invitations",
    seoTags: {
        title: "Bridal Shower Invitations & Wedding Shower Invites | WeddingWire",
        description: "Bridal shower invitations that are easy to customize and make it easy to stick to your budget. Shop your favorite bridal and wedding shower invitation designs for your wedding.",
        abstract: "Bridal shower invitations that are easy to customize and make it easy to stick to your budget. Shop your favorite bridal and wedding shower invitation designs for your wedding.",
        robots: "index, follow"
    },
    href: "/bridal-shower-invitations",
    parentSku: "INVI"
};
var rehearsalDinnerInvitatons = {
    sku: "RDI",
    name: "Rehearsal Dinner Invitations",
    seoTags: {
        title: "Rehersal Dinner Invitations | Easily Customizable Designs | WeddingWire",
        description: "Rehearsal dinner invitations that are easy to customize and make it easy to stick to your budget. Shop your favorite rehearsal dinner invite designs for your wedding.",
        abstract: "Rehearsal dinner invitations that are easy to customize and make it easy to stick to your budget. Shop your favorite rehearsal dinner invite designs for your wedding.",
        robots: "index, follow"
    },
    href: "/rehearsal-dinner-invitations",
    parentSku: "INVI"
};
var invitations = {
    sku: "INVI",
    name: "Invitations",
    seoTags: {
        title: "Wedding Invitations | Elegant to Rustic Designs | WeddingWire",
        description: "Explore hundreds of affordable wedding invitations that are just your style. From elegant to rustic, customize an invitation designed for your love story.",
        abstract: "Explore hundreds of affordable wedding invitations that are just your style. From elegant to rustic, customize an invitation designed for your love story.",
        robots: "noindex, nofollow"
    },
    href: invitationsLink,
    subCategories: [
        weddingInvitations,
        enclosureCards,
        rsvpCards,
        envelopeLiners,
        bridalShowerInvitations,
        rehearsalDinnerInvitatons, 
    ]
};
var programs = {
    sku: "PRG",
    name: "Programs",
    seoTags: {
        title: "Wedding Programs | Easily Customizable Designs | WeddingWire",
        description: "Wedding programs that are easy to customize and make it easy to stick to your budget. Shop your favorite wedding program designs for your wedding.",
        abstract: "Wedding programs that are easy to customize and make it easy to stick to your budget. Shop your favorite wedding program designs for your wedding.",
        robots: "index, follow"
    },
    href: "/wedding-programs",
    parentSku: "CERE"
};
var placeCards = {
    sku: "PLC",
    name: "Place Cards",
    seoTags: {
        title: "Wedding Place Cards | Easily Customizable Designs | WeddingWire",
        description: "Wedding place cards that are easy to customize and make it easy to stick to your budget. Shop your favorite wedding place cards designs for your wedding reception.",
        abstract: "Wedding place cards that are easy to customize and make it easy to stick to your budget. Shop your favorite wedding place cards designs for your wedding reception.",
        robots: "index, follow"
    },
    href: "/wedding-place-cards",
    parentSku: "CERE"
};
var menus = {
    sku: "MEN",
    name: "Menus",
    seoTags: {
        title: "Wedding Menus for Guests | Easily Customizable Designs | WeddingWire",
        description: "Wedding menus that are easy to customize and make it easy to stick to your budget. Shop your favorite wedding menu designs for your wedding reception.",
        abstract: "Wedding menus that are easy to customize and make it easy to stick to your budget. Shop your favorite wedding menu designs for your wedding reception.",
        robots: "index, follow"
    },
    href: "/wedding-menus",
    parentSku: "CERE"
};
var tableNumbers = {
    sku: "TNB",
    name: "Table Numbers",
    seoTags: {
        title: "Wedding Table Numbers | Easily Customizable Designs | WeddingWire",
        description: "Wedding table numbers that are easy to customize and make it easy to stick to your budget. Shop your favorite table number designs for your wedding reception.",
        abstract: "Wedding table numbers that are easy to customize and make it easy to stick to your budget. Shop your favorite table number designs for your wedding reception.",
        robots: "index, follow"
    },
    href: "/wedding-table-numbers",
    parentSku: "CERE"
};
var stickers = {
    sku: "STK",
    name: "Stickers",
    seoTags: {
        title: "Wedding Stickers | Easily Customizable Designs | WeddingWire",
        description: "Wedding stickers that are easy to customize and make it easy to stick to your budget. Shop your favorite wedding sticker designs for your wedding.",
        abstract: "Wedding stickers that are easy to customize and make it easy to stick to your budget. Shop your favorite wedding sticker designs for your wedding.",
        robots: "index, follow"
    },
    href: "/wedding-stickers",
    parentSku: "CERE"
};
var giftTags = {
    sku: "GFT",
    name: "Gift Tags",
    seoTags: {
        title: "Wedding Gift Tags | Easily Customizable Designs | WeddingWire",
        description: "Wedding gift tags that are easy to customize and make it easy to stick to your budget. Shop your favorite wedding gift tag designs for your wedding.",
        abstract: "Wedding gift tags that are easy to customize and make it easy to stick to your budget. Shop your favorite wedding gift tag designs for your wedding.",
        robots: "index, follow"
    },
    href: "/wedding-gift-tags",
    parentSku: "CERE"
};
var guestBooks = {
    sku: "GBK",
    name: "Guest Books",
    seoTags: {
        title: "Wedding Guest Books | Easily Customizable Designs | WeddingWire",
        description: "Wedding guest books that are easy to customize and make it easy to stick to your budget. Shop your favorite guest book designs for your wedding.",
        abstract: "Wedding guest books that are easy to customize and make it easy to stick to your budget. Shop your favorite guest book designs for your wedding.",
        robots: "index, follow"
    },
    href: "/wedding-guest-books",
    parentSku: "CERE"
};
var ceremonyAndReception = {
    sku: "CERE",
    name: "Ceremony & Reception",
    seoTags: {
        title: "Ceremony, Reception and Wedding Day Stationery | WeddingWire",
        description: "Wow guests with customizable ceremony and reception stationery. Find memorable touches for your wedding day including programs, menus, guest books and more.",
        abstract: "Wow guests with customizable ceremony and reception stationery. Find memorable touches for your wedding day including programs, menus, guest books and more.",
        robots: "noindex, nofollow"
    },
    href: ceremonyReceptionLink,
    subCategories: [
        programs,
        placeCards,
        guestBooks,
        menus,
        stickers,
        tableNumbers,
        giftTags
    ]
};
var thankyouCards = {
    sku: "TYC",
    name: "Thank You Cards",
    seoTags: {
        title: "Thank You Cards | Easily Customizable Designs | WeddingWire",
        description: "Thank you cards that are easy to customize and make it easy to stick to your budget. Shop your favorite thank you card designs for your wedding.",
        abstract: "Thank you cards that are easy to customize and make it easy to stick to your budget. Shop your favorite thank you card designs for your wedding.",
        robots: "index, follow"
    },
    href: "/thank-you-cards",
    parentSku: "TKYS"
};
var thankyouPostCards = {
    sku: "TYP",
    name: "Thank You Postcards",
    seoTags: {
        title: "Thank You Postcards | Easily Customizable Designs | WeddingWire",
        description: "Thank you postcards that are easy to customize and make it easy to stick to your budget. Shop your favorite thank you postcard designs for your wedding.",
        abstract: "Thank you postcards that are easy to customize and make it easy to stick to your budget. Shop your favorite thank you postcard designs for your wedding.",
        robots: "index, follow"
    },
    href: "/thank-you-postcards",
    parentSku: "TKYS"
};
var thankyou = {
    sku: "TKYS",
    name: "Thank Yous",
    seoTags: {
        title: "Wedding Thank You Cards | Elegant to Rustic Designs | WeddingWire",
        description: "Show guests your love and appreciation with customizable wedding thank-you cards. Available in a variety of designs, from elegant to rustic.",
        abstract: "Show guests your love and appreciation with customizable wedding thank-you cards. Available in a variety of designs, from elegant to rustic.",
        robots: "noindex, nofollow"
    },
    href: thankYousLink,
    subCategories: [
        thankyouCards,
        thankyouPostCards
    ]
};
var responseCardEnvelopes = {
    sku: "RSCENV",
    name: "Response Card Envelopes",
    href: "",
    parentSku: "ENVE"
};
var weddingInvitationEnvelopes = {
    sku: "WINENV",
    name: "Wedding Invitation Envelopes",
    href: "",
    parentSku: "ENVE"
};
var saveTheDateCardEnvelopes = {
    sku: "SDCENV",
    name: "Save the Date Card Envelopes",
    href: "",
    parentSku: "ENVE"
};
var bridalShowerInvitationEnvelopes = {
    sku: "BRIENV",
    name: "Bridal Shower Invitation Envelopes",
    href: "",
    parentSku: "ENVE"
};
var rehearsalDinnerInvitationEnvelopes = {
    sku: "RDIENV",
    name: "Rehearsal Dinner Invitation Envelopes",
    href: "",
    parentSku: "ENVE"
};
var thankYouCardEnvelopes = {
    sku: "TYCENV",
    name: "Thank You Card Envelopes",
    href: "",
    parentSku: "ENVE"
};
var changeTheDateCardEnvelopes = {
    sku: "CDCENV",
    name: "Change The Date Card Envelopes",
    href: "",
    parentSku: "ENVE"
};
var envelopes = {
    sku: "ENVE",
    name: "Envelopes",
    seoTags: {
        title: "Wedding Invitation and RSVP Envelopes | WeddingWire",
        description: "Browse our collection of envelopes to put the perfect finishing touch on your wedding invitations and stationery.",
        abstract: "Browse our collection of envelopes to put the perfect finishing touch on your wedding invitations and stationery.",
        robots: null
    },
    href: envelopesLink,
    subCategories: [
        responseCardEnvelopes,
        weddingInvitationEnvelopes,
        saveTheDateCardEnvelopes,
        bridalShowerInvitationEnvelopes,
        rehearsalDinnerInvitationEnvelopes,
        thankYouCardEnvelopes,
        changeTheDateCardEnvelopes, 
    ]
};
var _obj;
var categoriesSkuToCategoryMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, thankyou.sku, thankyou), (0,_define_property/* default */.Z)(_obj, thankyouPostCards.sku, thankyouPostCards), (0,_define_property/* default */.Z)(_obj, thankyouCards.sku, thankyouCards), (0,_define_property/* default */.Z)(_obj, ceremonyAndReception.sku, ceremonyAndReception), (0,_define_property/* default */.Z)(_obj, guestBooks.sku, guestBooks), (0,_define_property/* default */.Z)(_obj, giftTags.sku, giftTags), (0,_define_property/* default */.Z)(_obj, stickers.sku, stickers), (0,_define_property/* default */.Z)(_obj, tableNumbers.sku, tableNumbers), (0,_define_property/* default */.Z)(_obj, menus.sku, menus), (0,_define_property/* default */.Z)(_obj, placeCards.sku, placeCards), (0,_define_property/* default */.Z)(_obj, programs.sku, programs), (0,_define_property/* default */.Z)(_obj, invitations.sku, invitations), (0,_define_property/* default */.Z)(_obj, weddingInvitations.sku, weddingInvitations), (0,_define_property/* default */.Z)(_obj, rsvpCards.sku, rsvpCards), (0,_define_property/* default */.Z)(_obj, enclosureCards.sku, enclosureCards), (0,_define_property/* default */.Z)(_obj, envelopeLiners.sku, envelopeLiners), (0,_define_property/* default */.Z)(_obj, bridalShowerInvitations.sku, bridalShowerInvitations), (0,_define_property/* default */.Z)(_obj, rehearsalDinnerInvitatons.sku, rehearsalDinnerInvitatons), (0,_define_property/* default */.Z)(_obj, changeTheDates.sku, changeTheDates), (0,_define_property/* default */.Z)(_obj, changeTheDateCards.sku, changeTheDateCards), (0,_define_property/* default */.Z)(_obj, changeTheDatePostCards.sku, changeTheDatePostCards), (0,_define_property/* default */.Z)(_obj, saveTheDates.sku, saveTheDates), (0,_define_property/* default */.Z)(_obj, saveTheDateCards.sku, saveTheDateCards), (0,_define_property/* default */.Z)(_obj, saveTheDatePostCards.sku, saveTheDatePostCards), (0,_define_property/* default */.Z)(_obj, envelopes.sku, envelopes), (0,_define_property/* default */.Z)(_obj, responseCardEnvelopes.sku, responseCardEnvelopes), (0,_define_property/* default */.Z)(_obj, weddingInvitationEnvelopes.sku, weddingInvitationEnvelopes), (0,_define_property/* default */.Z)(_obj, saveTheDateCardEnvelopes.sku, saveTheDateCardEnvelopes), (0,_define_property/* default */.Z)(_obj, bridalShowerInvitationEnvelopes.sku, bridalShowerInvitationEnvelopes), (0,_define_property/* default */.Z)(_obj, rehearsalDinnerInvitationEnvelopes.sku, rehearsalDinnerInvitationEnvelopes), (0,_define_property/* default */.Z)(_obj, thankYouCardEnvelopes.sku, thankYouCardEnvelopes), (0,_define_property/* default */.Z)(_obj, changeTheDateCardEnvelopes.sku, changeTheDateCardEnvelopes), _obj);
var _obj1;
var categoriesHrefToCategoryMap = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, thankyou.href, thankyou), (0,_define_property/* default */.Z)(_obj1, thankyouPostCards.href, thankyouPostCards), (0,_define_property/* default */.Z)(_obj1, thankyouCards.href, thankyouCards), (0,_define_property/* default */.Z)(_obj1, ceremonyAndReception.href, ceremonyAndReception), (0,_define_property/* default */.Z)(_obj1, guestBooks.href, guestBooks), (0,_define_property/* default */.Z)(_obj1, giftTags.href, giftTags), (0,_define_property/* default */.Z)(_obj1, stickers.href, stickers), (0,_define_property/* default */.Z)(_obj1, tableNumbers.href, tableNumbers), (0,_define_property/* default */.Z)(_obj1, menus.href, menus), (0,_define_property/* default */.Z)(_obj1, placeCards.href, placeCards), (0,_define_property/* default */.Z)(_obj1, programs.href, programs), (0,_define_property/* default */.Z)(_obj1, invitations.href, invitations), (0,_define_property/* default */.Z)(_obj1, weddingInvitations.href, weddingInvitations), (0,_define_property/* default */.Z)(_obj1, rsvpCards.href, rsvpCards), (0,_define_property/* default */.Z)(_obj1, enclosureCards.href, enclosureCards), (0,_define_property/* default */.Z)(_obj1, envelopeLiners.href, envelopeLiners), (0,_define_property/* default */.Z)(_obj1, bridalShowerInvitations.href, bridalShowerInvitations), (0,_define_property/* default */.Z)(_obj1, rehearsalDinnerInvitatons.href, rehearsalDinnerInvitatons), (0,_define_property/* default */.Z)(_obj1, changeTheDates.href, changeTheDates), (0,_define_property/* default */.Z)(_obj1, changeTheDateCards.href, changeTheDateCards), (0,_define_property/* default */.Z)(_obj1, changeTheDatePostCards.href, changeTheDatePostCards), (0,_define_property/* default */.Z)(_obj1, saveTheDates.href, saveTheDates), (0,_define_property/* default */.Z)(_obj1, saveTheDateCards.href, saveTheDateCards), (0,_define_property/* default */.Z)(_obj1, saveTheDatePostCards.href, saveTheDatePostCards), (0,_define_property/* default */.Z)(_obj1, envelopes.href, envelopes), (0,_define_property/* default */.Z)(_obj1, responseCardEnvelopes.href, responseCardEnvelopes), (0,_define_property/* default */.Z)(_obj1, weddingInvitationEnvelopes.href, weddingInvitationEnvelopes), (0,_define_property/* default */.Z)(_obj1, saveTheDateCardEnvelopes.href, saveTheDateCardEnvelopes), (0,_define_property/* default */.Z)(_obj1, bridalShowerInvitationEnvelopes.href, bridalShowerInvitationEnvelopes), (0,_define_property/* default */.Z)(_obj1, rehearsalDinnerInvitationEnvelopes.href, rehearsalDinnerInvitationEnvelopes), (0,_define_property/* default */.Z)(_obj1, thankYouCardEnvelopes.href, thankYouCardEnvelopes), (0,_define_property/* default */.Z)(_obj1, changeTheDateCardEnvelopes.href, changeTheDateCardEnvelopes), _obj1);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(82222);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
// EXTERNAL MODULE: ./modules/core/components/BadgesNav/ww/styles.scss
var styles = __webpack_require__(80412);
var styles_default = /*#__PURE__*/__webpack_require__.n(styles);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(15317);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(48069);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./modules/core/components/CategoryLink/index.tsx



var CategoryLink = function(param) {
    var subnavLinkData = param.subnavLinkData, onClick = param.onClick;
    var name = subnavLinkData.name, href = subnavLinkData.href, nameTextOverride = subnavLinkData.nameTextOverride;
    var displayName = nameTextOverride !== null && nameTextOverride !== void 0 ? nameTextOverride : name;
    var handleOnClick = function(e) {
        if (onClick) {
            onClick(e, subnavLinkData);
        }
        router_default().push(href);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            onClick: handleOnClick,
            "data-test": "subnav-link",
            children: displayName
        })
    });
};
/* harmony default export */ var components_CategoryLink = (CategoryLink);

// EXTERNAL MODULE: ./modules/core/services/analytics/index.tsx
var analytics = __webpack_require__(92737);
;// CONCATENATED MODULE: ./modules/core/components/BadgesNav/ww/index.tsx






var runAnalyticsEvent = function(loggedIn, destinationCategory, currentCategory) {
    var event = loggedIn ? "NavigationAuthed" : "Navigation";
    var params = {
        label: "d-mobile_app+s-paper+o-{".concat(currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.replace("/", ""), "}+dt-{").concat(destinationCategory.replace("/", ""), "}")
    };
    (0,analytics/* trackInteraction */.LW)(event, params);
};
var BadgesNav = function(param) {
    var loggedIn = param.loggedIn, categories = param.categories, selectedCategory = param.selectedCategory;
    var isBrowser = function() {
        return "object" !== "undefined";
    };
    var refToElement = (0,react.useRef)(null);
    var ref = (0,react.useState)(categories), currentCategories = ref[0], setCurrentCategories = ref[1];
    (0,react.useEffect)(function() {
        if (isBrowser()) {
            if ((typeof localStorage === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(localStorage)) !== undefined && localStorage.getItem) {
                setCurrentCategories(JSON.parse(localStorage.getItem("currentCategories")));
            }
        }
    }, []);
    (0,react.useEffect)(function() {
        if ((typeof localStorage === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(localStorage)) !== undefined && localStorage.setItem) {
            localStorage.setItem("currentCategories", JSON.stringify(currentCategories));
        }
    }, [
        currentCategories
    ]);
    var handleOnClick = function(_event, category) {
        var ref;
        runAnalyticsEvent(loggedIn, category.href, selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.href);
        (ref = refToElement.current) === null || ref === void 0 ? void 0 : ref.scrollTo({
            left: 0,
            behavior: "smooth"
        });
    };
    (0,react.useEffect)(function() {
        setCurrentCategories(function(current) {
            return !selectedCategory ? categories : selectedCategory.subCategories || current;
        });
    }, [
        selectedCategory,
        categories
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_default()).scrollWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            className: (styles_default()).badgeList,
            ref: refToElement,
            children: [
                !(selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.subCategories) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: selectedCategory ? (styles_default()).selectedCategory : (styles_default()).hideEmptyItem,
                    children: selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.name
                }),
                currentCategories.map(function(category) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                        className: (selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.href) === category.href ? (styles_default()).hideSelectedCategory : "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CategoryLink, {
                            onClick: function(e) {
                                return handleOnClick(e, category);
                            },
                            subnavLinkData: category
                        })
                    }, category.id);
                })
            ]
        })
    });
};
/* harmony default export */ var ww = (BadgesNav);

// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/components/FooterNav/index.js + 51 modules
var FooterNav = __webpack_require__(83825);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/components/FooterNav/components/FooterLink/index.js
var FooterLink = __webpack_require__(55961);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-footer-nav/lib/css/index.css
var css = __webpack_require__(15618);
var css_default = /*#__PURE__*/__webpack_require__.n(css);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(68325);
// EXTERNAL MODULE: ./modules/shared/Feature/FeatureToggle/FeatureToggleContext.tsx
var FeatureToggleContext = __webpack_require__(31459);
;// CONCATENATED MODULE: ./modules/core/components/Footer/index.tsx






var privacyChoicesHandler = function() {
    if (true) {
        var ref;
        (ref = window.UnionConsentManagement) === null || ref === void 0 ? void 0 : ref.togglePreferencesModal();
    }
};
var footerLinksData = [
    {
        content: "Privacy Policy",
        href: "https://www.theknotww.com/privacy-policy/"
    },
    {
        content: "Terms of Use",
        href: "https://www.theknotww.com/terms-of-use/"
    },
    {
        content: "Accessibility",
        href: "https://www.theknotww.com/accessibility-statement/"
    },
    {
        content: "Do Not Sell My Info",
        href: "https://theknotww.zendesk.com/hc/en-us/requests/new?ticket_form_id=360000590371"
    },
    {
        content: "CA Privacy",
        href: "https://www.theknotww.com/ca-collection-notice/"
    },
    {
        content: "Customer Service",
        href: "https://helpcenter.theknot.com/"
    },
    {
        content: "Shipping + Order Policies",
        href: "https://www.theknot.com/paper/shipping-order-policies"
    },
    {
        content: "Offer Terms",
        href: "https://www.theknot.com/paper/offers"
    }, 
];
// Conditionally adding CMP link to footer data links
if (FeatureToggleContext/* FEATURES.cmp */.h6.cmp) {
    footerLinksData.push({
        content: "Your Privacy Choices",
        onClick: privacyChoicesHandler,
        href: "#"
    });
}
var CopyrightItem = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
    className: (css_default()).copyrightItem,
    style: {
        color: "#fff"
    },
    children: [
        " ",
        "\xa9 2019-".concat(new Date().getFullYear(), " Save Our Date, LLC"),
        " "
    ]
});
var customFooterLinks = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.ZP, {
        once: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
            className: (css_default()).businessLinksContainer,
            children: [
                footerLinksData.map(function(link, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink/* default */.Z, {
                        className: (css_default()).businessItemBase,
                        onClick: link.onClick,
                        href: link.href,
                        children: link.content
                    }, index);
                }),
                CopyrightItem
            ]
        })
    });
};
var Footer = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterNav/* default */.Z, {
        analyticsProps: {
            product: "paper"
        },
        renderFooterLinks: customFooterLinks,
        ssi: true
    });
};
/* harmony default export */ var components_Footer = (Footer);

// EXTERNAL MODULE: ./ui/ImageWrapper/ImageTKWW.tsx
var ImageTKWW = __webpack_require__(44030);
// EXTERNAL MODULE: ./utils/helpers/index.ts
var helpers = __webpack_require__(96645);
// EXTERNAL MODULE: ./node_modules/@tkww/paper-zendesk/lib/index.js
var paper_zendesk_lib = __webpack_require__(70132);
// EXTERNAL MODULE: ./modules/core/components/Footer/ww/styles.scss
var ww_styles = __webpack_require__(69601);
var ww_styles_default = /*#__PURE__*/__webpack_require__.n(ww_styles);
;// CONCATENATED MODULE: ./modules/core/components/Footer/ww/countrySelectorContent.tsx



var CountrySelectorContent = function(param) {
    var title = param.title, data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ww_styles_default()).countrySelectorModal__content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    className: (ww_styles_default()).countrySelectorModal__subtitle,
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: (ww_styles_default()).countrySelectorModalList,
                    children: data.map(function(link, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: (ww_styles_default()).countrySelectorModalList__item,
                                rel: "nofollow",
                                href: link.href,
                                title: link.text,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageTKWW/* ImageTKWW */.$A, {
                                        src: "https://www.weddingwire.com/assets/img/paper/flags/" + link.img + "",
                                        className: (ww_styles_default()).countrySelectorModalList__flag,
                                        width: 18,
                                        height: 12,
                                        alt: link.text
                                    }),
                                    link.text
                                ]
                            })
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var countrySelectorContent = (CountrySelectorContent);

;// CONCATENATED MODULE: ./modules/core/components/Footer/ww/footerLinks.tsx



var FooterLinks = function(param) {
    var title = param.title, data = param.data;
    var onClick = function onClick(link) {
        if (link.content && "object" !== "undefined") {
            window.analytics.track("Footer Interaction", {
                platform: platform,
                product: "paper",
                selection: link.content
            });
        }
    };
    var platform = (0,useTracking/* useTracking */.r)().platform;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (ww_styles_default()).linkingFooter__title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: data.map(function(link, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: link.href,
                            rel: link.rel,
                            target: link.target,
                            onClick: (link === null || link === void 0 ? void 0 : link.onClick) || onClick(link),
                            children: link.content
                        })
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var footerLinks = (FooterLinks);

;// CONCATENATED MODULE: ./modules/core/components/Footer/ww/footerLinksData.tsx



var HOST = "https://www.theknot.com";
var corporativeLinksData = [
    {
        content: "Weddings Home",
        href: HOST
    },
    {
        content: "About us",
        href: HOST + "/corp/about-us"
    },
    {
        content: "Editorial Team & Policies",
        href: HOST + "/wedding-ideas/about-us"
    },
    {
        content: "Nondiscrimination",
        href: "https://go.weddingwire.com/nondiscrimination"
    },
    {
        content: "Careers",
        href: HOST + "/corp/careers"
    },
    {
        content: "Press Center",
        href: HOST + "/press"
    },
    {
        content: "Advertising",
        href: HOST + "/corp/advertise"
    },
    {
        content: "Terms of Use",
        href: HOST + "/corp/legal/terms-of-use",
        rel: "nofollow"
    },
    {
        content: "Privacy Policy",
        href: HOST + "/corp/legal/privacy-policy",
        rel: "nofollow"
    },
    {
        content: "Shipping + Order Policies",
        href: HOST + "/wedding-paper/page/shipping-policies"
    },
    {
        content: "Do Not Sell My Info",
        href: HOST + "/privacy/noSaleForm"
    },
    {
        content: "CA Privacy",
        href: HOST + "/ca-collection-notice"
    },
    {
        content: "Web Accessibility",
        href: HOST + "/accessibility-statement",
        rel: "nofollow"
    }, 
];
if (FeatureToggleContext/* FEATURES.cmp */.h6.cmp) {
    corporativeLinksData.push({
        content: "Your Privacy Choices",
        href: "#",
        rel: "nofollow",
        onClick: privacyChoicesHandler
    });
}
var vendorsLinksData = [
    {
        content: "Directory",
        href: HOST + "/wedding-vendors"
    },
    {
        content: "Reviews",
        href: HOST + "/vendor-reviews"
    },
    {
        content: "Couples' Choice Awards",
        href: HOST + "/couples-choice-awards"
    },
    {
        content: "Gay Weddings",
        href: HOST + "/gay-weddings"
    }, 
];
var toolsLinksData = [
    {
        content: "Wedding Website",
        href: HOST + "/wedding-websites.html"
    },
    {
        content: "Wedding Invitations",
        href: HOST + "/wedding-paper/wedding-invitations"
    },
    {
        content: "Checklist",
        href: HOST + "/wedding-checklists.html"
    },
    {
        content: "Guest List",
        href: HOST + "/wedding-planning/wedding-guests-list.html"
    },
    {
        content: "Budget",
        href: HOST + "/wedding-planning/wedding-budget.html"
    },
    {
        content: "Vendor Manager",
        href: HOST + "/wedding-planning/vendor-manager.html"
    },
    {
        content: "Seating Chart",
        href: HOST + "/wedding-planning/wedding-seating-tables.html"
    },
    {
        content: "Hotel Blocks",
        href: "https://hotelblocks.weddingwire.com/Group-Rate/?sc=WW_Footer&utm_source=weddingwire&utm_medium=onsite&utm_campaign=footer"
    },
    {
        content: "Cost Guide",
        href: HOST + "/cost"
    },
    {
        content: "Help",
        href: "https://wedding-wire.zendesk.com/",
        target: "_blank",
        rel: "nofollow noopener noreferrer"
    }, 
];
var utilsLinksData = [
    {
        content: "Wedding App",
        href: HOST + "/wedding-apps"
    },
    {
        content: "Hashtag Generator",
        href: HOST + "/wedding-hashtag-generator"
    },
    {
        content: "Wedding Giveaways",
        href: "https://go.weddingwire.com/giveaways"
    },
    {
        content: "Wedding Timeline",
        href: HOST + "/wedding-ideas/wedding-timeline"
    },
    {
        content: "Color Generator",
        href: "https://go.weddingwire.com/color-palette-generator"
    },
    {
        content: "Real Weddings",
        href: HOST + "/wedding-photos/real-weddings"
    },
    {
        content: "Honeymoons",
        href: HOST + "/honeymoons"
    }, 
];
var goToLinksData = [
    {
        content: "Find a couple's wedding website",
        href: "https://www.weddingwire.us"
    }
];
var areYouVendorLinksData = [
    {
        content: "Learn about Weddingwire for Business",
        href: HOST + "/vendors/home"
    },
    {
        content: "Visit vendor support",
        href: "https://support.weddingwire.com/hc/en-us"
    }, 
];
var downloadAppLinksData = [
    {
        href: "https://app.appsflyer.com/id316565575?pid=WP-iOS-US&amp;c=WP-US-LANDINGS&amp;s=us",
        src: "https://www.weddingwire.com/assets/img/footer/appstore.png",
        srcset: "https://www.weddingwire.com/assets/img/footer/appstore@2x.png 2x",
        alt: "Download the WeddingWire App on the App Store"
    },
    {
        href: "https://app.appsflyer.com/com.weddingwire.user?pid=WP-Android-US&amp;c=WP-US-LANDINGS",
        src: "https://www.weddingwire.com/assets/img/footer/googleplay.png",
        srcset: "https://www.weddingwire.com/assets/img/footer/googleplay@2x.png 2x",
        alt: "Get the WeddingWire App on Google Play"
    }, 
];
var countryEuropeLinksData = [
    {
        href: "https://www.bodas.net",
        text: "Spain",
        img: "es.png"
    },
    {
        href: "https://www.mariages.net",
        text: "France",
        img: "fr.png"
    },
    {
        href: "https://www.matrimonio.com",
        text: "Italy",
        img: "it.png"
    },
    {
        href: "https://www.hitched.co.uk",
        text: "United Kingdom",
        img: "uk.png"
    },
    {
        href: "https://www.hitched.ie",
        text: "Ireland",
        img: "ie.png"
    },
    {
        href: "https://www.casamentos.pt",
        text: "Portugal",
        img: "pt.png"
    }, 
];
var countryAsiaLinksData = [
    {
        href: "https://www.weddingwire.in",
        text: "India",
        img: "in.png"
    }, 
];
var countryAmericaLinksData = [
    {
        href: "https://www.bodas.com.mx",
        text: "Mexico",
        img: "mx.png"
    },
    {
        href: "https://www.matrimonios.cl",
        text: "Chile",
        img: "cl.png"
    },
    {
        href: "https://www.casamientos.com.ar/",
        text: "Argentina",
        img: "ar.png"
    },
    {
        href: "https://www.casamentos.com.br",
        text: "Brazil",
        img: "br.png"
    },
    {
        href: "https://www.matrimonio.com.co",
        text: "Colombia",
        img: "co.png"
    },
    {
        href: "https://www.matrimonio.com.pe",
        text: "Peru",
        img: "pe.png"
    },
    {
        href: "https://www.casamiento.com.uy",
        text: "Uruguay",
        img: "uy.png"
    },
    {
        href: "https://www.weddingwire.ca",
        text: "Canada",
        img: "ca.png"
    }, 
];
var Facebook = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 1792 1792",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1343 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759h-306v-759h-255v-296h255v-218q0-186 104-288.5t277-102.5q147 0 228 12z"
        })
    });
};
var Twitter = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 502 408",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M501.625 48.375c-18.477 8.203-38.281 13.71-59.102 16.21 21.25-12.733 37.579-32.89 45.235-56.874a206.477 206.477 0 01-65.313 24.922c-18.75-20-45.468-32.461-75.039-32.461-56.797 0-102.851 46.016-102.851 102.812 0 8.047.937 15.899 2.695 23.438C161.781 122.125 86.04 81.188 35.297 18.96 26.43 34.195 21.39 51.85 21.39 70.68c0 35.664 18.125 67.148 45.742 85.625-16.875-.547-32.735-5.196-46.602-12.89v1.288c0 49.844 35.469 91.367 82.461 100.86-8.594 2.343-17.695 3.593-27.07 3.593-6.64 0-13.086-.625-19.375-1.875 13.125 40.82 51.094 70.625 96.055 71.446-35.157 27.578-79.493 43.984-127.696 43.984-8.32 0-16.484-.469-24.492-1.445 45.469 29.218 99.531 46.21 157.617 46.21 189.14 0 292.578-156.68 292.578-292.538 0-4.454-.117-8.946-.273-13.32 20.078-14.493 37.5-32.618 51.289-53.243z"
        })
    });
};
var Pinterest = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 1792 1792",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1664 896q0 209-103 385.5t-279.5 279.5-385.5 103q-111 0-218-32 59-93 78-164 9-34 54-211 20 39 73 67.5t114 28.5q121 0 216-68.5t147-188.5 52-270q0-114-59.5-214t-172.5-163-255-63q-105 0-196 29t-154.5 77-109 110.5-67 129.5-21.5 134q0 104 40 183t117 111q30 12 38-20 2-7 8-31t8-30q6-23-11-43-51-61-51-151 0-151 104.5-259.5t273.5-108.5q151 0 235.5 82t84.5 213q0 170-68.5 289t-175.5 119q-61 0-98-43.5t-23-104.5q8-35 26.5-93.5t30-103 11.5-75.5q0-50-27-83t-77-33q-62 0-105 57t-43 142q0 73 25 122l-99 418q-17 70-13 177-206-91-333-281t-127-423q0-209 103-385.5t279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
        })
    });
};
var Instagram = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 1792 1792",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1152 896q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zm138 0q0 164-115 279t-279 115-279-115-115-279 115-279 279-115 279 115 115 279zm108-410q0 38-27 65t-65 27-65-27-27-65 27-65 65-27 65 27 27 65zm-502-220q-7 0-76.5-.5t-105.5 0-96.5 3-103 10-71.5 18.5q-50 20-88 58t-58 88q-11 29-18.5 71.5t-10 103-3 96.5 0 105.5.5 76.5-.5 76.5 0 105.5 3 96.5 10 103 18.5 71.5q20 50 58 88t88 58q29 11 71.5 18.5t103 10 96.5 3 105.5 0 76.5-.5 76.5.5 105.5 0 96.5-3 103-10 71.5-18.5q50-20 88-58t58-88q11-29 18.5-71.5t10-103 3-96.5 0-105.5-.5-76.5.5-76.5 0-105.5-3-96.5-10-103-18.5-71.5q-20-50-58-88t-88-58q-29-11-71.5-18.5t-103-10-96.5-3-105.5 0-76.5.5zm768 630q0 229-5 317-10 208-124 322t-322 124q-88 5-317 5t-317-5q-208-10-322-124t-124-322q-5-88-5-317t5-317q10-208 124-322t322-124q88-5 317-5t317 5q208 10 322 124t124 322q5 88 5 317z"
        })
    });
};
var socialLinksData = [
    {
        href: "https://www.facebook.com/weddingwire",
        title: "Facebook",
        svg: /*#__PURE__*/ (0,jsx_runtime.jsx)(Facebook, {})
    },
    {
        href: "https://twitter.com/weddingwire",
        title: "Twitter",
        svg: /*#__PURE__*/ (0,jsx_runtime.jsx)(Twitter, {})
    },
    {
        href: "https://www.pinterest.com/weddingwire",
        title: "Pinterest",
        svg: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pinterest, {})
    },
    {
        href: "https://www.instagram.com/weddingwire",
        title: "Instagram",
        svg: /*#__PURE__*/ (0,jsx_runtime.jsx)(Instagram, {})
    }, 
];

;// CONCATENATED MODULE: ./modules/core/components/Footer/ww/index.tsx









var date = new Date().getFullYear();
var ww_Footer = function() {
    var ref = (0,react.useState)(false), modalIsOpen = ref[0], setModalIsOpen = ref[1];
    var onModalOpenHandler = function() {
        setModalIsOpen(true);
        (0,paper_zendesk_lib.updateSettingZendeskClassic)("hide", undefined, function(error) {
            return (0,helpers/* handleZendeskOnError */.w2)(error, "footer-ww");
        });
    };
    var onModalCloseHandler = function() {
        setModalIsOpen(false);
        (0,paper_zendesk_lib.updateSettingZendeskClassic)("show", undefined, function(error) {
            return (0,helpers/* handleZendeskOnError */.w2)(error, "footer-ww");
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ww_styles_default()).layoutFooter,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ww_styles_default()).linkingFooter,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: (ww_styles_default()).corporativeLinks,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(footerLinks, {
                            title: "Weddingwire",
                            data: corporativeLinksData
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(footerLinks, {
                            title: "Find vendors",
                            data: vendorsLinksData
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: (ww_styles_default()).toolsLinks,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footerLinks, {
                        title: "Planning Tools",
                        data: toolsLinksData
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: (ww_styles_default()).utilsLinks,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(footerLinks, {
                            title: "More",
                            data: utilsLinksData
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(footerLinks, {
                            title: "Going to a wedding?",
                            data: goToLinksData
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(footerLinks, {
                            title: "Are you a vendor?",
                            data: areYouVendorLinksData
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: (ww_styles_default()).appsAndSocialLinks,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (ww_styles_default()).linkingFooter__title,
                            children: "Download the WeddingWire App"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ww_styles_default()).appsAndSocialLinks__description,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ww_styles_default()).appsAndSocialLinks__image,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageTKWW/* ImageTKWW */.$A, {
                                        src: "https://www.weddingwire.com/mobile/assets/img/download-app@2x.png",
                                        alt: "App icon",
                                        width: "48",
                                        height: "48"
                                    })
                                }),
                                "Plan your wedding anytime, anywhere"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: (ww_styles_default()).appsAndSocialLinks__list,
                            children: downloadAppLinksData.map(function(link, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        rel: "nofollow noopener noreferrer",
                                        href: link.href,
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageTKWW/* ImageTKWW */.$A, {
                                            src: link.src,
                                            alt: link.alt,
                                            width: "140",
                                            height: "42"
                                        })
                                    })
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (ww_styles_default()).linkingFooter__title,
                            children: "Connect with us"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: (ww_styles_default()).appsAndSocialLinks__list,
                            children: socialLinksData.map(function(link, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: (ww_styles_default()).appsAndSocialLinks__item,
                                        rel: "nofollow noopener noreferrer",
                                        href: link.href,
                                        title: link.title,
                                        target: "_blank",
                                        children: link.svg
                                    })
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (ww_styles_default()).linkingFooter__title,
                            children: "Choose a country"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ww_styles_default()).countrySelector__wrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ww_styles_default()).countrySelector__dropdown,
                                onClick: onModalOpenHandler,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ww_styles_default()).countrySelector__flag,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageTKWW/* ImageTKWW */.$A, {
                                            src: "https://www.weddingwire.com/assets/img/paper/flags/usa.png",
                                            width: "18",
                                            height: "12",
                                            alt: "United States"
                                        })
                                    }),
                                    "United States",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (ww_styles_default()).countrySelector__icon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            viewBox: "0 0 18 18",
                                            width: "18",
                                            height: "18",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M16.9 5.6c-.2-.2-.5-.2-.7 0L9 12.8 1.8 5.6c-.2-.2-.5-.2-.7 0s-.2.5 0 .7l7.5 7.5v.1c.1.1.3.1.4.1.1 0 .3 0 .4-.1v-.1l7.5-7.5c.2-.2.2-.5 0-.7z",
                                                fill: "#222222"
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        modalIsOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ww_styles_default()).modal,
                            role: "dialog",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ww_styles_default()).modal__content,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (ww_styles_default()).countrySelectorModal,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                className: (ww_styles_default()).countrySelectorModal__title,
                                                children: [
                                                    "Choose a country",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (ww_styles_default()).countrySelectorModal__closeIcon,
                                                        onClick: onModalCloseHandler,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            viewBox: "0 0 26 26",
                                                            width: "26",
                                                            height: "26",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M12.983 10.862L23.405.439l2.122 2.122-10.423 10.422 10.423 10.422-2.122 2.122-10.422-10.423L2.561 25.527.439 23.405l10.423-10.422L.439 2.561 2.561.439l10.422 10.423z",
                                                                fillRule: "nonzero"
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (ww_styles_default()).countrySelectorModal__body,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(countrySelectorContent, {
                                                        title: "Europe",
                                                        data: countryEuropeLinksData
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(countrySelectorContent, {
                                                        title: "Asia",
                                                        data: countryAsiaLinksData
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(countrySelectorContent, {
                                                        title: "Americas",
                                                        data: countryAmericaLinksData
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ww_styles_default()).modal__overlay
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: (ww_styles_default()).copyrightFooter,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageTKWW/* ImageTKWW */.$A, {
                            src: "https://www.weddingwire.com/assets/img/footer/tkww_logo_KO_2x.png",
                            alt: "ww logo",
                            width: "140",
                            height: "48"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "\xa9 2006 - ",
                                date
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Footer_ww = (ww_Footer);

// EXTERNAL MODULE: ./routing/brandRoutes.tsx
var brandRoutes = __webpack_require__(84250);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(72730);
// EXTERNAL MODULE: ./domains/product/legacy/Catalog/hooks.tsx
var hooks = __webpack_require__(28336);
// EXTERNAL MODULE: ./utils/analytics/helpers.ts
var analytics_helpers = __webpack_require__(74504);
// EXTERNAL MODULE: ./utils/config/config.constants.ts
var config_constants = __webpack_require__(76806);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(69967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(53143);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(17377);
// EXTERNAL MODULE: ./ui/Typography/Typography.tsx
var Typography = __webpack_require__(22655);
// EXTERNAL MODULE: ./ui/Link/DisplayLink.tsx
var DisplayLink = __webpack_require__(83430);
;// CONCATENATED MODULE: ./ui/Banner/PencilBanner/PencilBanner.adapter.tsx






function linkTarget(href) {
    return href.includes(String("")) ? "_self" : "_blank";
}
function renderPencilText(document) {
    var _obj;
    var options = {
        renderNode: (_obj = {}, (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.PARAGRAPH, function(node, children) {
            return children ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* PaperBody1 */.nu, {
                children: children
            }) : null;
        }), (0,_define_property/* default */.Z)(_obj, dist.INLINES.HYPERLINK, function(param, children) {
            var data = param.data;
            return children && (data === null || data === void 0 ? void 0 : data.uri) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayLink/* default */.Z, {
                id: "pencil-text-link",
                color: "secondary",
                href: data.uri,
                target: linkTarget(data.uri),
                children: children
            }) : null;
        }), _obj),
        renderText: function(text) {
            if (!text) return;
            return text;
        }
    };
    return (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(document.json, options);
}

// EXTERNAL MODULE: ./ui/Banner/PencilBanner/PencilBannerTK.module.scss
var PencilBannerTK_module = __webpack_require__(19237);
var PencilBannerTK_module_default = /*#__PURE__*/__webpack_require__.n(PencilBannerTK_module);
// EXTERNAL MODULE: ./ui/Banner/PencilBanner/PencilBannerWW.module.scss
var PencilBannerWW_module = __webpack_require__(22067);
var PencilBannerWW_module_default = /*#__PURE__*/__webpack_require__.n(PencilBannerWW_module);
;// CONCATENATED MODULE: ./ui/Banner/PencilBanner/PencilBanner.tsx













function redirectTo(link) {
    return window.location.assign(link);
}
var PencilBanner_styles = (0,config_constants/* isTenant */.J)("ww") ? (PencilBannerWW_module_default()) : (PencilBannerTK_module_default());
var PencilBanner = function(param) {
    var location = param.location, page = param.page, text = param.text, backgroundColor = param.backgroundColor, bannerLink = param.bannerLink, promotion = param.promotion;
    var ref = (0,react.useState)(false), isViewed = ref[0], setIsViewed = ref[1];
    var bannerRef = (0,react.useRef)(null);
    var trackingData = (0,useTracking/* useTracking */.r)();
    var isVisible = (0,hooks/* default */.Z)(bannerRef);
    var promotionTrackingData = (0,react.useMemo)(function() {
        return {
            promotion_id: (0,analytics_helpers/* trackingString */.L_)(promotion === null || promotion === void 0 ? void 0 : promotion.sys.id),
            creative: "",
            name: (0,analytics_helpers/* trackingString */.L_)(promotion === null || promotion === void 0 ? void 0 : promotion.name),
            position: page && location ? (0,analytics_helpers/* trackingString */.L_)("".concat(page, " ").concat(location, " Banner")) : ""
        };
    }, [
        promotion,
        page,
        location
    ]);
    (0,react.useEffect)(function() {
        var anchor = document.getElementById("pencil-text-link");
        if (!anchor) return;
        var handleClick = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            e === null || e === void 0 ? void 0 : e.stopImmediatePropagation();
                            e === null || e === void 0 ? void 0 : e.preventDefault();
                            return [
                                4,
                                (0,analytics_helpers/* trackPromotionClicked */.xn)((0,_object_spread/* default */.Z)({}, promotionTrackingData, trackingData), function() {
                                    return redirectTo(anchor.href);
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function handleClick(e) {
                return _ref.apply(this, arguments);
            };
        }();
        anchor.addEventListener("click", handleClick);
        return function() {
            return anchor.removeEventListener("click", handleClick);
        };
    }, [
        promotionTrackingData,
        trackingData
    ]);
    (0,react.useEffect)(function() {
        if ( false || isViewed || !isVisible) return;
        (0,analytics_helpers/* trackPromotionViewed */.oX)((0,_object_spread/* default */.Z)({}, promotionTrackingData, trackingData));
        setIsViewed(true);
    }, [
        isVisible,
        promotionTrackingData,
        trackingData,
        isViewed
    ]);
    if (!text) return null;
    var bgColor = (backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.replace("#", "color-").toLowerCase()) || "";
    function handleBannerClick() {
        return _handleBannerClick.apply(this, arguments);
    }
    function _handleBannerClick() {
        _handleBannerClick = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!bannerLink) return [
                            2
                        ];
                        return [
                            4,
                            (0,analytics_helpers/* trackPromotionClicked */.xn)((0,_object_spread/* default */.Z)({}, promotionTrackingData, trackingData), function() {
                                return redirectTo(bannerLink);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _handleBannerClick.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()(PencilBanner_styles.banner, PencilBanner_styles[bgColor]),
        ref: bannerRef,
        onClick: handleBannerClick,
        onAuxClick: handleBannerClick,
        children: renderPencilText(text)
    });
};

// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-header-nav/lib/remote.js + 7 modules
var remote = __webpack_require__(53275);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(41414);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./modules/core/components/Header/MembershipAuthModal/MembershipAuthModal.helpers.ts
var MembershipAuthModal_helpers = __webpack_require__(69333);
;// CONCATENATED MODULE: ./modules/core/components/Header/index.tsx











var MembershipAuthModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4991), __webpack_require__.e(1150), __webpack_require__.e(6338), __webpack_require__.e(234), __webpack_require__.e(4626), __webpack_require__.e(6360), __webpack_require__.e(3603)]).then(__webpack_require__.bind(__webpack_require__, 86360));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86360)
            ];
        }
    }
});
var product = "paper";
var Header = function(param) {
    var loggedIn = param.loggedIn, logOutCallback = param.logOutCallback, pencil = param.pencil;
    var ref = (0,react.useState)(null), authModal = ref[0], setAuthModal = ref[1];
    var ref1 = (0,router.useRouter)(), pathname = ref1.pathname, asPath = ref1.asPath;
    var isPLP = pathname === brandRoutes/* PRODUCT_LIST_ROUTE */.Uq;
    var isCart = pathname === brandRoutes/* CART_ROUTE */.WP;
    var isCheckout = pathname.includes(brandRoutes/* CHECKOUT_ROUTE */.S7) && !pathname.includes(brandRoutes/* CONFIRMATION_ROUTE */.tM);
    (0,react.useEffect)(function() {
        if (authModal) {
            (0,paper_zendesk_lib.updateSettingZendeskClassic)("updateSettings", {
                zIndex: 5
            }, function(error) {
                return (0,helpers/* handleZendeskOnError */.w2)(error, "header");
            });
        }
        return function() {
            (0,paper_zendesk_lib.updateSettingZendeskClassic)("updateSettings", {
                zIndex: 9999
            }, function(error) {
                return (0,helpers/* handleZendeskOnError */.w2)(error, "header");
            });
        };
    }, [
        authModal
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (isPLP || isCart) && pencil && /*#__PURE__*/ (0,jsx_runtime.jsx)(PencilBanner, (0,_object_spread/* default */.Z)({}, pencil), asPath),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(remote/* default */.ZP, {
                activeProduct: "invitations",
                analyticsProps: {
                    product: product
                },
                metadata: {
                    applicationName: product
                },
                onClickLogOut: logOutCallback,
                onClickLogIn: function() {
                    return setAuthModal(MembershipAuthModal_helpers/* MembershipAuthIntents.logIn */.Fe.logIn);
                },
                onClickSignUp: function() {
                    return setAuthModal(MembershipAuthModal_helpers/* MembershipAuthIntents.signUp */.Fe.signUp);
                },
                loggedIn: loggedIn,
                ssi: true,
                __renderDraftsLink__: true
            }),
            authModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipAuthModal, {
                intent: authModal,
                setOpenModal: setAuthModal
            }),
            isCheckout && pencil && /*#__PURE__*/ (0,jsx_runtime.jsx)(PencilBanner, (0,_object_spread/* default */.Z)({}, pencil))
        ]
    });
};
/* harmony default export */ var components_Header = (Header);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(55323);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./modules/core/components/Header/ww/styles.scss
var Header_ww_styles = __webpack_require__(38325);
var Header_ww_styles_default = /*#__PURE__*/__webpack_require__.n(Header_ww_styles);
;// CONCATENATED MODULE: ./modules/core/components/Header/ww/headerFunctions.tsx



var onNavigationMenuHandle = function() {
    var dropdown = document.querySelector(".app-header-menu");
    var navOpenClass = (Header_ww_styles_default()).layoutHeader__navOpen;
    var isNavOpen = dropdown === null || dropdown === void 0 ? void 0 : dropdown.classList.contains(navOpenClass);
    (0,paper_zendesk_lib.updateSettingZendeskClassic)("updateSettings", {
        zIndex: isNavOpen ? 9999 : 5
    }, function(error) {
        return (0,helpers/* handleZendeskOnError */.w2)(error, "header-ww");
    });
    dropdown === null || dropdown === void 0 ? void 0 : dropdown.classList.toggle(navOpenClass);
};
var onSubmenuHandle = function(e) {
    var ref, ref1;
    var self = e.currentTarget;
    var itemElements = {
        closeSection: self.querySelector(".app-header-menu-item-closeSection"),
        dropdown: self.querySelector(".app-header-menu-itemDropdown")
    };
    (ref = itemElements.dropdown) === null || ref === void 0 ? void 0 : ref.classList.toggle((Header_ww_styles_default())["layoutNavMenuTab--open"]);
    (ref1 = itemElements.closeSection) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("click", function() {
        self.classList.remove((Header_ww_styles_default())["layoutNavMenuTab--open"]);
    });
};

// EXTERNAL MODULE: ./modules/core/components/Header/ww/headerLinksData.tsx
var headerLinksData = __webpack_require__(62292);
;// CONCATENATED MODULE: ./modules/core/components/Header/ww/submenu.tsx



var Submenu = function(param) {
    var title = param.title, submenu = param.submenu;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "".concat((Header_ww_styles_default()).layoutNavMenuTab, " app-header-menu-itemDropdown"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Header_ww_styles_default()).layoutNavMenuTab__layout,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Header_ww_styles_default()).layoutNavMenuTab__header,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: (Header_ww_styles_default()).layoutNavMenuTab__icon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                viewBox: "0 0 20 36",
                                width: "20",
                                height: "36",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M18.769.653a2.004 2.004 0 00-2.961 0L1.245 16.17c-.09.07-.175.147-.256.233A2.302 2.302 0 00.376 18c-.005.578.2 1.157.613 1.598.08.086.167.164.256.233l14.563 15.515a2.004 2.004 0 002.96 0c.744-.791.812-2.031.204-2.904l-.203-.25L5.449 18 18.77 3.809l.203-.25c.608-.874.54-2.113-.203-2.906z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (Header_ww_styles_default()).layoutNavMenuTab__title,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: (Header_ww_styles_default()).layoutNavMenuTab__iconClose,
                            onClick: onNavigationMenuHandle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                viewBox: "0 0 26 26",
                                width: "26",
                                height: "26",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M12.983 10.862L23.405.439l2.122 2.122-10.423 10.422 10.423 10.422-2.122 2.122-10.422-10.423L2.561 25.527.439 23.405l10.423-10.422L.439 2.561 2.561.439l10.422 10.423z"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Header_ww_styles_default()).layoutNavMenuTabSubmenu,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Header_ww_styles_default()).layoutNavMenuTabSubmenuList,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: (Header_ww_styles_default()).layoutNavMenuTabSubmenuList__content,
                            children: submenu === null || submenu === void 0 ? void 0 : submenu.map(function(link, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "".concat((Header_ww_styles_default()).layoutNavMenuTabSubmenuList__item, " ").concat(link.colorPrimary ? (Header_ww_styles_default())["layoutNavMenuTabSubmenuList__item--primary"] : ""),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: link.href,
                                        children: link.content
                                    })
                                }, index);
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var submenu = (Submenu);

;// CONCATENATED MODULE: ./modules/core/components/Header/ww/index.tsx











var hostUrl = String("https://www.theknot.com");
var ww_Header = function(param) {
    var loggedIn = param.loggedIn, userData = param.userData, pencil = param.pencil;
    var avatar = userData === null || userData === void 0 ? void 0 : userData.avatar;
    var letterName = userData === null || userData === void 0 ? void 0 : userData.username.charAt(0);
    var ref = (0,router.useRouter)(), asPath = ref.asPath, basePath = ref.basePath, pathname = ref.pathname;
    var currentPath = String(basePath + asPath);
    var isPLP = pathname === brandRoutes/* PRODUCT_LIST_ROUTE */.Uq;
    var isCartOrCheckout = pathname === brandRoutes/* CART_ROUTE */.WP || pathname.includes(brandRoutes/* CHECKOUT_ROUTE */.S7) && !pathname.includes(brandRoutes/* CONFIRMATION_ROUTE */.tM);
    var avatarIcon;
    if (avatar === null || avatar === void 0 ? void 0 : avatar.url) {
        avatarIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageTKWW/* ImageTKWW */.$A, {
            alt: userData === null || userData === void 0 ? void 0 : userData.username,
            src: avatar === null || avatar === void 0 ? void 0 : avatar.url,
            layout: "fill"
        });
    } else {
        avatarIcon = /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            className: "avatar__svg",
            viewBox: "0 0 200 200",
            preserveAspectRatio: "xMidYMin slice",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    fill: avatar === null || avatar === void 0 ? void 0 : avatar.color,
                    cx: "100",
                    cy: "100",
                    r: "100"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                    transform: "translate(100,130)",
                    y: "0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tspan", {
                        fontSize: "90",
                        className: "",
                        fill: "rgba(255,255,255,1)",
                        textAnchor: "middle",
                        children: letterName
                    })
                })
            ]
        });
    }
    var numMessages = userData === null || userData === void 0 ? void 0 : userData.unreadMessagesCount;
    var messages;
    numMessages === "0" ? messages = false : messages = true;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isPLP && pencil && /*#__PURE__*/ (0,jsx_runtime.jsx)(PencilBanner, (0,_object_spread/* default */.Z)({}, pencil), asPath),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Header_ww_styles_default()).layoutHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Header_ww_styles_default()).layoutHeader__hamburger,
                        onClick: onNavigationMenuHandle,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            viewBox: "0 0 18 20",
                            width: "18",
                            height: "20",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M14.17 15.42a.5.5 0 01.09.992l-.09.008H1a.5.5 0 01-.09-.992L1 15.42h13.17zm2.927-5.76a.5.5 0 01.09.991l-.09.008H1a.5.5 0 01-.09-.991L1 9.659h16.097zm0-5.66a.5.5 0 01.09.992l-.09.008H1a.5.5 0 01-.09-.992L1 4h16.097z"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: (Header_ww_styles_default()).layoutHeader__logoAnchor,
                        href: hostUrl,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "https://www.weddingwire.com/assets/img/logos/gen_logoHeader.svg",
                            alt: "Weddings",
                            width: "194",
                            height: "29"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "".concat((Header_ww_styles_default()).layoutHeader__nav, " app-header-menu"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: (Header_ww_styles_default()).layoutNavMenu,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: (Header_ww_styles_default()).layoutNavMenu__header,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: (Header_ww_styles_default()).layoutNavMenu__itemClose,
                                        onClick: onNavigationMenuHandle,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            viewBox: "0 0 26 26",
                                            width: "26",
                                            height: "26",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M12.983 10.862L23.405.439l2.122 2.122-10.423 10.422 10.423 10.422-2.122 2.122-10.422-10.423L2.561 25.527.439 23.405l10.423-10.422L.439 2.561 2.561.439l10.422 10.423z"
                                            })
                                        })
                                    })
                                }),
                                headerLinksData/* navigationLinksData.map */.SV.map(function(link, index) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                                        className: "\n              ".concat((Header_ww_styles_default()).layoutNavMenu__item, " \n              ").concat(link.mutableTablet ? (Header_ww_styles_default())["layoutNavMenu__item--mutableTablet"] : "", "\n              ").concat(link.mutableDesktop ? (Header_ww_styles_default())["layoutNavMenu__item--mutableDesktop"] : "", "\n              "),
                                        onClick: onSubmenuHandle,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: (Header_ww_styles_default()).layoutNavMenu__anchor,
                                                href: link.href,
                                                rel: link.rel,
                                                target: link.target,
                                                children: link.content
                                            }),
                                            (link === null || link === void 0 ? void 0 : link.submenu) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (Header_ww_styles_default()).layoutNavMenu__anchorArrow,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            viewBox: "0 0 582 998",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M0 83c0 8.7 3.3 16.3 10 23l393 393L10 892c-6.7 6.7-10 14.3-10 23s3.3 16.3 10 23l50 50c6.7 6.7 14.3 10 23 10s16.3-3.3 23-10l466-466c6.7-6.7 10-14.3 10-23s-3.3-16.3-10-23L106 10C99.3 3.3 91.7 0 83 0S66.7 3.3 60 10L10 60C3.3 66.7 0 74.3 0 83z"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(submenu, {
                                                        title: link.content,
                                                        submenu: link === null || link === void 0 ? void 0 : link.submenu
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index);
                                }),
                                headerLinksData/* navigationFooterLinksData.map */.fH.map(function(link, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "\n              ".concat((Header_ww_styles_default()).layoutNavMenu__itemFooter, " \n              ").concat(link.bordered ? (Header_ww_styles_default())["layoutNavMenu__itemFooter--bordered"] : "", "\n              ").concat(link.primary ? (Header_ww_styles_default())["layoutNavMenu__itemFooter--colored"] : "", "\n              "),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: (Header_ww_styles_default()).layoutNavMenu__anchorFooter,
                                            href: link.href,
                                            target: link.target,
                                            children: link.content
                                        })
                                    }, index);
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Header_ww_styles_default()).layoutHeader__overlay,
                        onClick: onNavigationMenuHandle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Header_ww_styles_default()).layoutHeader__authArea,
                        children: [
                            !loggedIn && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "".concat(headerLinksData/* loginRoute */.VU, "?r=").concat(currentPath),
                                        rel: "nofollow",
                                        className: (Header_ww_styles_default()).layoutHeader__authNoLoggedAreaMobile,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: (Header_ww_styles_default()).svgIcon,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                viewBox: "0 0 47 53",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M31.722 29.786C40.49 32.99 46.78 42.236 46.78 51.962v1H.846v-1c0-9.615 6.156-18.77 14.774-22.069-2.971-1.686-5.407-4.324-6.774-7.691-3.236-7.981.75-17.009 8.891-20.172 8.13-3.154 17.343.736 20.575 8.698 2.915 7.181-.03 15.22-6.59 19.058zm-12.16 1.698l-2.469.006c-7.922 2.633-13.8 10.765-14.222 19.472h41.885c-.423-8.744-6.343-16.9-14.309-19.501l-2.786.006a16.09 16.09 0 01-8.099.017zm-1.1-27.59c-7.11 2.762-10.576 10.617-7.763 17.556 2.82 6.944 10.88 10.347 17.998 7.582 7.107-2.761 10.575-10.62 7.762-17.551C33.64 4.537 25.579 1.133 18.46 3.895z"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Header_ww_styles_default()).layoutHeader__authNoLoggedArea,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                className: (Header_ww_styles_default()).layoutHeader__vendorAuth,
                                                rel: "nofollow",
                                                href: "".concat(hostUrl, "/vendors/home"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "".concat((Header_ww_styles_default()).svgIcon, " ").concat((Header_ww_styles_default()).layoutHeader__vendorAuthIcon),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            viewBox: "0 0 48 41",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M44.3 27.917h.933V13.925c0-1.46-1.199-2.86-3.057-3.625H5.825c-1.859.766-3.058 2.164-3.058 3.625v13.992h14.866V24.39a1 1 0 011-1h10.734a1 1 0 011 1v3.527H44.3zm-2.133 2h-11.8v.51a1 1 0 01-1 1H18.633a1 1 0 01-1-1v-.51h-11.8v8.564h36.334v-8.564zM14.567 8.3v-.51c0-3.797 2.855-7.035 6.533-7.035h5.8c3.68 0 6.533 3.236 6.533 7.036V8.3h8.935a1 1 0 01.358.066c2.655 1.02 4.507 3.115 4.507 5.559v14.992a1 1 0 01-1 1h-2.066v9.564a1 1 0 01-1 1H4.833a1 1 0 01-1-1v-9.564H1.767a1 1 0 01-1-1V13.925c0-2.445 1.852-4.54 4.509-5.559a1 1 0 01.358-.066h8.933zm13.8 21.126V25.39h-8.734v4.036h8.734zm3.066-21.635c0-2.747-2.018-5.036-4.533-5.036h-5.8c-2.513 0-4.533 2.29-4.533 5.036V8.3h14.866v-.51z"
                                                            })
                                                        })
                                                    }),
                                                    "ARE YOU A VENDOR?"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: (Header_ww_styles_default()).layoutNavMenuAuth,
                                                children: headerLinksData/* login.map */.x4.map(function(link, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: (Header_ww_styles_default()).layoutNavMenuAuth__item,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: (Header_ww_styles_default()).layoutNavMenuAuth__anchor,
                                                            href: "".concat(link.href, "?").concat(link.redirectPath, "=").concat(currentPath),
                                                            children: link.content
                                                        })
                                                    }, index);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            loggedIn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: (Header_ww_styles_default()).layoutNavMenuAuthLogged,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (Header_ww_styles_default()).layoutNavMenuAuthLogged__item,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: (Header_ww_styles_default()).layoutNavMenuAuthLogged__itemAnchor,
                                            href: "".concat(hostUrl, "/users-saved.php"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (Header_ww_styles_default()).layoutNavMenuAuthLogged__itemFavoriteIcon,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                    viewBox: "0 0 34 30",
                                                    width: "34",
                                                    height: "30",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M26.232.086C30.653.716 34 4.68 34 9.858c0 1.41-.371 2.884-1.073 4.412-1.35 2.937-3.878 6.013-7.247 9.134a68.921 68.921 0 01-5.582 4.625c-.665.496-1.284.941-1.84 1.328-.335.233-.577.396-.71.483a1 1 0 01-1.097 0c-.132-.087-.374-.25-.71-.483a67.429 67.429 0 01-1.84-1.328 68.921 68.921 0 01-5.58-4.625c-3.37-3.121-5.898-6.197-7.248-9.134C.371 12.742 0 11.268 0 9.858 0 4.681 3.347.716 7.768.086 11.6-.46 15.091 1.616 17 5.778 18.91 1.617 22.4-.46 26.232.086z"
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (Header_ww_styles_default()).layoutNavMenuAuthLogged__item,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Header_ww_styles_default()).layoutNavMenuAuthLoggedInbox,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                className: (Header_ww_styles_default()).layoutNavMenuAuthLogged__itemAnchor,
                                                href: "".concat(hostUrl, "/users-mailbox.php"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (Header_ww_styles_default()).layoutNavMenuAuthLoggedInbox__icon,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            viewBox: "0 0 20 15",
                                                            width: "22",
                                                            height: "22",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M18.912 12.604V1.995c0-.47-.406-.911-.8-.911H1.888c-.393 0-.799.441-.799.911v10.609c0 .466.402.896.8.896h16.225c.397 0 .799-.43.799-.896zm1 0c0 1.003-.834 1.896-1.8 1.896H1.888c-.965 0-1.799-.893-1.799-1.896V1.995C.088.991.923.084 1.888.084h16.225c.964 0 1.799.907 1.799 1.911v10.609zm-9.631-4.71a.5.5 0 01-.562.827L2.513 3.828a.5.5 0 01.562-.827l7.206 4.893zm7.18 1.85a.5.5 0 01-.552.834l-3.29-2.175a.5.5 0 11.552-.834l3.29 2.175zm-14.37.834a.5.5 0 01-.552-.834l3.29-2.175a.5.5 0 11.551.834l-3.29 2.175zm7.185-1.859a.5.5 0 11-.562-.827l7.206-4.893a.5.5 0 01.562.827l-7.206 4.893z"
                                                            })
                                                        })
                                                    }),
                                                    messages && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (Header_ww_styles_default()).layoutNavMenuAuthLoggedInbox__counter,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (Header_ww_styles_default()).layoutNavMenuAuthLoggedInbox__number,
                                                            children: userData === null || userData === void 0 ? void 0 : userData.unreadMessagesCount
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (Header_ww_styles_default()).layoutNavMenuAuthLogged__avatar,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Header_ww_styles_default()).layoutNavMenuAuthLogged__avatarContainer,
                                            children: avatarIcon
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            isCartOrCheckout && pencil && /*#__PURE__*/ (0,jsx_runtime.jsx)(PencilBanner, (0,_object_spread/* default */.Z)({}, pencil))
        ]
    });
};
/* harmony default export */ var Header_ww = (ww_Header);

// EXTERNAL MODULE: ./modules/core/components/ScrollToTop/index.tsx + 1 modules
var ScrollToTop = __webpack_require__(11036);
// EXTERNAL MODULE: ./modules/core/components/Seo/index.tsx + 1 modules
var Seo = __webpack_require__(64188);
// EXTERNAL MODULE: ./modules/core/components/SubNavApp/ww/styles.scss
var SubNavApp_ww_styles = __webpack_require__(84128);
var SubNavApp_ww_styles_default = /*#__PURE__*/__webpack_require__.n(SubNavApp_ww_styles);
;// CONCATENATED MODULE: ./modules/core/components/SubNavApp/ww/index.tsx



function getCategory(categories, selectedCategory) {
    if (selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.subCategories) {
        return selectedCategory.name;
    }
    var categoryName = categories.filter(function(category) {
        var ref;
        return selectedCategory && (category === null || category === void 0 ? void 0 : (ref = category.subCategories) === null || ref === void 0 ? void 0 : ref.includes(selectedCategory));
    }).map(function(category) {
        return category.name;
    });
    return categoryName.length > 0 ? categoryName[0] : null;
}
var SubNavApp = function(param) {
    var selectedCategory = param.selectedCategory, categories = param.categories;
    var category = getCategory(categories, selectedCategory);
    if (!category) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SubNavApp_ww_styles_default()).pageSubtitleFreeSampleContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SubNavApp_ww_styles_default()).categoryHeader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: category
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/page/free-wedding-invitation-samples",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: (SubNavApp_ww_styles_default()).freeSampleContainer,
                        children: " Free Sample"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var SubNavApp_ww = (SubNavApp);

// EXTERNAL MODULE: ./modules/core/contexts/ItemNotice/index.tsx + 4 modules
var ItemNotice = __webpack_require__(19951);
// EXTERNAL MODULE: ./modules/core/contexts/membershipAuth/index.tsx
var membershipAuth = __webpack_require__(17380);
// EXTERNAL MODULE: ./modules/core/services/honeybadger.service.ts
var honeybadger_service = __webpack_require__(69354);
// EXTERNAL MODULE: ./modules/core/services/impact/index.tsx
var impact = __webpack_require__(58314);
// EXTERNAL MODULE: ./modules/helpers/mobileScreenHook.tsx
var mobileScreenHook = __webpack_require__(16774);
// EXTERNAL MODULE: ./modules/shared/Feature/FeatureToggle/useFeatureToggle.tsx
var useFeatureToggle = __webpack_require__(76411);
// EXTERNAL MODULE: ./routing/externalApp.tsx
var externalApp = __webpack_require__(39313);
// EXTERNAL MODULE: ./utils/helpers/constants.ts
var constants = __webpack_require__(51529);
// EXTERNAL MODULE: ./node_modules/@honeybadger-io/react/dist/honeybadger-react.esm.js
var honeybadger_react_esm = __webpack_require__(37627);
// EXTERNAL MODULE: ./node_modules/@tkww/paper-subnav/lib/index.js
var paper_subnav_lib = __webpack_require__(64338);
// EXTERNAL MODULE: ./node_modules/@xo-union/tab-accessibility/lib/index.js
var tab_accessibility_lib = __webpack_require__(56303);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-layout/lib/components/Layout.js + 4 modules
var Layout = __webpack_require__(87947);
// EXTERNAL MODULE: ./modules/core/components/NotificationToast/NotificationToast/index.module.scss
var index_module = __webpack_require__(66338);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./modules/shared/NoticeBanner/index.tsx
var NoticeBanner = __webpack_require__(28378);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-alerts/lib/components/ControlledSnackbar/index.js + 1 modules
var ControlledSnackbar = __webpack_require__(7477);
;// CONCATENATED MODULE: ./modules/core/components/NotificationToast/NotificationToast/index.tsx






var NotificationToast = function(param) {
    var children = param.children, isDisplayed = param.isDisplayed, isMobile = param.isMobile, handleOnClose = param.handleOnClose, _type = param.type, type = _type === void 0 ? "success" : _type;
    var snackbar = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (isDisplayed) {
            if (isMobile) {
                var ref;
                var notificationTimeout = 4000;
                snackbar === null || snackbar === void 0 ? void 0 : (ref = snackbar.current) === null || ref === void 0 ? void 0 : ref.showAndDismiss({
                    data: /*#__PURE__*/ (0,react.cloneElement)(children, {
                        hasSnackbarWrapper: true
                    }),
                    dismissTimeout: notificationTimeout
                });
            } else {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            }
        }
    }, [
        isDisplayed
    ]);
    var notificationToastStyleClassesArray = [
        (index_module_default()).container
    ];
    if ((0,config_constants/* isTenant */.J)("ww")) {
        notificationToastStyleClassesArray.push((index_module_default()).container__ww);
    }
    var notificationToastStyleClasses = notificationToastStyleClassesArray.join(" ");
    return isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledSnackbar/* default */.Z, {
        ref: snackbar
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: notificationToastStyleClasses,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).body,
            "data-testid": "notification-toast",
            children: children && /*#__PURE__*/ (0,jsx_runtime.jsx)(NoticeBanner["default"], {
                type: type,
                handleOnClose: handleOnClose,
                styleOverrides: {
                    noticeBanner: (index_module_default()).noticeBannerOverrides
                },
                isDisplayed: isDisplayed,
                children: children
            })
        })
    });
};
/* harmony default export */ var NotificationToast_NotificationToast = (NotificationToast);

// EXTERNAL MODULE: ./data/updatedCategoryHierarchyData.tsx
var updatedCategoryHierarchyData = __webpack_require__(80207);
;// CONCATENATED MODULE: ./modules/core/components/Layout/helpers.tsx





var getValidCategoryUrl = function(path) {
    var result;
    var isSaveTheDate = /(?!\/products).*\?.*save-the-dates$/.test(path);
    result = path.split("?")[0];
    switch(true){
        case /(?!\/products).*\?.*format=standard$/.test(path) && isSaveTheDate:
            result += "?format=standard";
            break;
        case /(?!\/products).*\?.*format=postcard$/.test(path) && isSaveTheDate:
            result += "?format=postcard";
            break;
        case /(?!\/products).*\?.*format=all-in-one$/.test(path):
            result += "?format=all-in-one";
            break;
        case /(?!\/products).*\?.*format=petite$/.test(path):
            result += "?format=petite";
            break;
        case /(?!\/products).*\?.*format=magnet$/.test(path):
            result += "?format=magnet";
            break;
    }
    return result;
};
var createDomainCategoryObject = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(urlPath) {
        var url, category;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = getValidCategoryUrl(urlPath);
                    return [
                        4,
                        findCategoryObject(url)
                    ];
                case 1:
                    category = _state.sent();
                    if (!category) return [
                        2,
                        undefined
                    ];
                    return [
                        2,
                        {
                            category: category,
                            seoTags: category.seoTags
                        }
                    ];
            }
        });
    });
    return function createDomainCategoryObject(urlPath) {
        return _ref.apply(this, arguments);
    };
}();
var findCategoryObject = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(path) {
        var categories, _path;
        return (0,tslib_es6.__generator)(this, function(_state) {
            categories = getEnabledHrefCategories();
            return [
                2,
                (_path = categories[path]) !== null && _path !== void 0 ? _path : undefined
            ];
        });
    });
    return function findCategoryObject(path) {
        return _ref.apply(this, arguments);
    };
}();
function getEnabledHrefCategories() {
    return (0,config_constants/* isTenant */.J)("ww") ? categoriesHrefToCategoryMap : updatedCategoryHierarchyData/* categoriesHrefToCategoryMap */.Dk;
}


;// CONCATENATED MODULE: ./modules/core/components/Layout/hooks.tsx






var usePageViewRouteChangeComplete = function() {
    var ref, ref1;
    var trackingData = (0,useTracking/* useTracking */.r)();
    // We need to avoid re-rendering, but in the meantime we can get super defensive by calculating a key
    // to be used on useCallback and avoid firing events more than once.
    var parts = String((globalThis === null || globalThis === void 0 ? void 0 : (ref = globalThis.window) === null || ref === void 0 ? void 0 : (ref1 = ref.location) === null || ref1 === void 0 ? void 0 : ref1.href) || "").split("?");
    var cleanUrl = parts[0];
    var searchParams = new URLSearchParams(parts[1]);
    searchParams.delete("q");
    var params = Object.fromEntries(searchParams.entries());
    var key = JSON.stringify((0,_object_spread/* default */.Z)({
        cleanUrl: cleanUrl
    }, params));
    (0,react.useEffect)(function() {
        if (!(globalThis === null || globalThis === void 0 ? void 0 : globalThis.window)) return;
        (0,analytics/* pageView */.tN)(trackingData);
    }, [
        key
    ]);
};
var useImpactIdentifyRouteChangeComplete = function(member) {
    var events = (0,router.useRouter)().events;
    var impactIdentifyCallback = (0,impact/* useImpactIdentifyCallback */.dm)(member);
    (0,react.useEffect)(function() {
        events.on("routeChangeComplete", impactIdentifyCallback);
        return function() {
            events.off("routeChangeComplete", impactIdentifyCallback);
        };
    }, [
        impactIdentifyCallback,
        events
    ]);
};
var useOnRouteChangeComplete = function(member) {
    usePageViewRouteChangeComplete();
    useImpactIdentifyRouteChangeComplete(member);
};


// EXTERNAL MODULE: ./modules/core/components/Layout/index.scss
var components_Layout = __webpack_require__(95241);
var Layout_default = /*#__PURE__*/__webpack_require__.n(components_Layout);
;// CONCATENATED MODULE: ./modules/core/components/Layout/index.tsx






































var weddingWireCategories = [
    invitations,
    saveTheDates,
    changeTheDates,
    ceremonyAndReception,
    thankyou
];
var LayoutWrapper = function(param) {
    var children = param.children, userProfile = param.userProfile, isApp = param.isApp, pencil = param.pencil, subNav = param.subNav;
    var ref, ref1;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,membershipAuth/* useMembership */.e7)(), 2), state = ref2[0], dispatch = ref2[1];
    var memberDispatch = dispatch;
    var isAuthStatusLoaded = state.fetched, memberState = (0,_object_without_properties/* default */.Z)(state, [
        "fetched"
    ]);
    var ref3 = (0,router.useRouter)(), asPath = ref3.asPath, pathname = ref3.pathname;
    var ref4 = (0,react.useState)(undefined), selectedCategory = ref4[0], setSelectedCategory = ref4[1];
    var trackingData = (0,useTracking/* useTracking */.r)();
    var ref5 = (0,useFeatureToggle/* useFeatureToggle */.X)(), isEnabled = ref5.isEnabled, features = ref5.features;
    var ref6 = (0,ItemNotice/* useItemNoticeContext */.p4)(), _itemNoticeState = ref6.itemNoticeState, displayNotificationMessage = _itemNoticeState.displayNotificationMessage, content = _itemNoticeState.content, noticeType = _itemNoticeState.noticeType, setItemNoticeState = ref6.setItemNoticeState, itemCountersState = ref6.itemCountersState;
    var additionalLink = isEnabled("HolidayLink") && (0,config_constants/* isTenant */.J)("tk") ? constants/* holidayLink */.o0 : undefined;
    useOnRouteChangeComplete(memberState.member);
    (0,impact/* useImpactIdentify */.PH)((ref = memberState.member) === null || ref === void 0 ? void 0 : ref.id, (ref1 = memberState.member) === null || ref1 === void 0 ? void 0 : ref1.email);
    (0,react.useEffect)(function() {
        var tabAccessibility = (0,tab_accessibility_lib/* default */.Z)();
        tabAccessibility.mount();
    }, []);
    (0,react.useEffect)(function() {
        if (memberState.authenticated) return;
        (0,membershipAuth/* fetchMember */.F$)(memberDispatch);
    }, [
        memberState.authenticated,
        memberDispatch
    ]);
    (0,react.useEffect)(function() {
        createDomainCategoryObject(asPath).then(function(domainCategory) {
            setSelectedCategory(domainCategory === null || domainCategory === void 0 ? void 0 : domainCategory.category);
        });
    }, [
        asPath
    ]);
    var handleOnItemNoticeClose = function() {
        setItemNoticeState(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                displayNotificationMessage: false
            });
        });
    };
    // Closes the item notice if router changes
    (0,react.useEffect)(function() {
        if (displayNotificationMessage) {
            handleOnItemNoticeClose();
        }
    }, [
        asPath
    ]);
    var isCheckout = pathname.includes(brandRoutes/* CHECKOUT_ROUTE */.S7) && !pathname.includes(brandRoutes/* CONFIRMATION_ROUTE */.tM);
    var onSearch = function(searchTerm) {
        (0,externalApp/* routeToExternalApp */.f)("/products?search=".concat(searchTerm));
    };
    var isMobile = (0,mobileScreenHook/* default */.Z)();
    var logoutCallbackHandler = function() {
        return (0,membershipAuth/* logOut */.ni)(memberDispatch).then(function() {
            (0,helpers/* handlePageLogout */.FM)();
        });
    };
    var header, footer, badgesNav, subNavApp, loggedIn;
    if ((0,config_constants/* isTenant */.J)("ww")) {
        loggedIn = Boolean(userProfile);
        header = !isApp && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_ww, {
            pencil: pencil,
            loggedIn: loggedIn,
            userData: userProfile
        });
        footer = !isApp && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_ww, {});
        badgesNav = Boolean(isApp) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ww, {
            loggedIn: loggedIn,
            selectedCategory: selectedCategory,
            categories: weddingWireCategories
        });
        subNavApp = Boolean(isApp) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubNavApp_ww, {
            selectedCategory: selectedCategory,
            categories: weddingWireCategories
        });
    } else {
        loggedIn = memberState.authenticated;
        header = /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Header, {
            pencil: pencil,
            loggedIn: loggedIn,
            logOutCallback: logoutCallbackHandler
        });
        footer = /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Footer, {});
        badgesNav = undefined;
        subNavApp = undefined;
    }
    var onMenuItemInteraction = function(value) {
        (0,analytics_helpers/* trackMenuInteraction */.kK)((0,_object_spread/* default */.Z)({
            selection: value
        }, trackingData));
    };
    var onProductsSearched = function(searchTerm) {
        return (0,analytics_helpers/* trackProductsSearched */.V$)((0,_object_spread/* default */.Z)({
            query: searchTerm
        }, trackingData));
    };
    //Horrible bridgerton hack to solve the Copyright unplanned task at release date.
    var ref7 = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (ref7.current) {
            var observer = new MutationObserver(function() {
                var ref;
                if (false) {}
                var hasBridgerton = String((ref = document === null || document === void 0 ? void 0 : document.getElementById("content")) === null || ref === void 0 ? void 0 : ref.outerHTML).toLowerCase()//submenu
                .replace('<a data-test="subnav-link" href="/paper/bridgerton">bridgerton x the knot</a>', "")//ff
                .replace('"bridgerton":true', "").includes("bridgerton");
                var el = document.getElementById("extra-copyright");
                if (el) {
                    el.innerHTML = hasBridgerton ? "\xa9 ".concat(new Date().getFullYear(), ' Netflix. All rights reserved. BRIDGERTON and Netflix marks <span style="font-family: sans-serif">™</span> Netflix. Shondaland mark <span style="font-family: sans-serif">™</span> Shondaland. Used with permission.') : "";
                    el.style.display = hasBridgerton ? "block" : "none";
                }
            });
            observer.observe(ref7.current, {
                childList: true,
                characterData: true,
                subtree: true
            });
            return function() {
                return observer.disconnect();
            };
        }
    }, []);
    var searchBarPlaceholder = "Search rustic, modern, floral...";
    if (!subNav) {
        throw new Error("menuTreeData is required");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Layout_default()).layoutWrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
                header: header,
                footer: footer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        isAuthStatusLoaded && !isCheckout && /*#__PURE__*/ (0,jsx_runtime.jsx)(paper_subnav_lib.PaperSubNav, {
                            isUserLoggedIn: loggedIn,
                            tenant: (0,config_constants/* isTenant */.J)("tk") ? "tk" : "ww",
                            trackMenuInteraction: onMenuItemInteraction,
                            trackProductsSearched: onProductsSearched,
                            onSearch: onSearch,
                            cartCount: itemCountersState.cart,
                            draftCount: itemCountersState.drafts,
                            searchBarPlaceholder: searchBarPlaceholder,
                            additionalLink: additionalLink,
                            menuTreeData: subNav
                        }),
                        (isEnabled("ToastNotifications") || pathname.includes("your-orders/")) && /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationToast_NotificationToast, {
                            isDisplayed: displayNotificationMessage,
                            isMobile: isMobile,
                            handleOnClose: handleOnItemNoticeClose,
                            type: noticeType,
                            children: content
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: subNavApp
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: badgesNav
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(honeybadger_react_esm/* HoneybadgerErrorBoundary */.t, {
                            honeybadger: honeybadger_service["default"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: ref7,
                                id: "content",
                                children: children
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollToTop/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "extra-copyright",
                            style: {
                                backgroundColor: "white",
                                textAlign: "center",
                                paddingBottom: "28px",
                                display: "none",
                                fontSize: "12px",
                                lineHeight: "16px"
                            }
                        })
                    ]
                })
            })
        })
    });
};
var WebLayout = function(param) {
    var children = param.children, seoTags = param.seoTags, userProfile = param.userProfile, itemCounters = param.itemCounters, pencil = param.pencil, subNav = param.subNav;
    var pathname = (0,router.useRouter)().pathname;
    var useSeo = pathname !== "/[...slug]";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            useSeo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo/* default */.Z, {
                seoTags: seoTags
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(paper_zendesk_lib.Zendesk, {
                tenant: config_constants/* CONFIG.tenant.shortName */.k.tenant.shortName,
                apiKey: String("da94a3e8-5e41-460f-8a1d-fe60c270d9f4"),
                onError: function(error) {
                    return (0,helpers/* handleZendeskOnError */.w2)(error);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemNotice/* ItemNoticeProvider */.xX, {
                    itemCounters: itemCounters,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutWrapper, {
                        pencil: pencil,
                        userProfile: userProfile,
                        subNav: subNav,
                        children: children
                    })
                })
            })
        ]
    });
};
var WebviewLayout = function(param) {
    var children = param.children, itemCounters = param.itemCounters;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemNotice/* ItemNoticeProvider */.xX, {
            itemCounters: itemCounters,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(honeybadger_react_esm/* HoneybadgerErrorBoundary */.t, {
                honeybadger: honeybadger_service["default"],
                children: children
            })
        })
    });
};
/* harmony default export */ var core_components_Layout = (WebLayout);


/***/ }),

/***/ 11036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ScrollToTop; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72491);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-icons/lib/components/Icon/index.js
var Icon = __webpack_require__(21647);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(69967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./modules/core/components/ScrollToTop/styles.module.scss
var styles_module = __webpack_require__(75401);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(48069);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
;// CONCATENATED MODULE: ./modules/helpers/scrollHook.tsx


var useRouterScroll = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _left = ref.left, left = _left === void 0 ? 0 : _left, _top = ref.top, top = _top === void 0 ? 0 : _top;
    var router = useRouter();
    useEffect(function() {
        // This fixes an inconsistent behaviour between `<Link/>` and `next/router`
        // See https://github.com/vercel/next.js/issues/3249
        var handleRouteChangeComplete = function() {
            window.scrollTo({
                top: top,
                left: left
            });
        };
        router.events.on("routeChangeComplete", handleRouteChangeComplete);
        return function() {
            router.events.off("routeChangeComplete", handleRouteChangeComplete);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        left,
        top
    ]);
};
var useShowScrollToTopArrow = function() {
    var ref = (0,react.useState)(false), showScrollArrow = ref[0], setShowScrollArrow = ref[1];
    (0,react.useEffect)(function() {
        var scrollListener = function() {
            setShowScrollArrow(window.scrollY > 300);
        };
        window.addEventListener("scroll", scrollListener);
        return function() {
            window.removeEventListener("scroll", scrollListener);
        };
    }, []);
    return showScrollArrow;
};


;// CONCATENATED MODULE: ./modules/core/components/ScrollToTop/index.tsx





var ScrollToTop = function() {
    var showArrow = useShowScrollToTopArrow();
    var onClickHandler = function() {
        return window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    var arrowClass = showArrow ? (styles_module_default()).isActive : "";
    var classNames = classnames_default()((styles_module_default()).scrollToTop, arrowClass);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        "data-testid": "scroll-to-top-button",
        className: classNames,
        onClick: onClickHandler,
        title: "Scroll to Top",
        tabIndex: -1,
        "aria-label": "Scroll to Top",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            className: (styles_module_default()).arrow,
            name: "caret_up"
        })
    });
};
/* harmony default export */ var components_ScrollToTop = (ScrollToTop);


/***/ }),

/***/ 64188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Seo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72491);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(20158);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(48069);
// EXTERNAL MODULE: ./utils/config/config.constants.ts
var config_constants = __webpack_require__(76806);
;// CONCATENATED MODULE: ./modules/core/components/Seo/constants.ts
var DEFAULT_SEO_META = {
    tk: {
        title: "Wedding Invitations and Save The Dates | The Knot",
        description: "Browse hundreds of gorgeous, customizable wedding invitations, save-the-dates and more from our affordable wedding stationery collection."
    },
    ww: {
        title: "Wedding Stationery: Invitations, RSVPs & More | WeddingWire",
        description: "From save-the-dates, wedding invitations to thank you cards, we have your wedding stationery covered. Customization is free and so are samples. Shop today!"
    }
};

;// CONCATENATED MODULE: ./modules/core/components/Seo/index.tsx





var DefaultSeo = function() {
    var title = DEFAULT_SEO_META.tk.title;
    var description = DEFAULT_SEO_META.tk.description;
    if ((0,config_constants/* isTenant */.J)("ww")) {
        title = DEFAULT_SEO_META.ww.title;
        description = DEFAULT_SEO_META.ww.description;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                children: [
                    " ",
                    title,
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            })
        ]
    });
};
var Seo = function(param) {
    var seoTags = param.seoTags;
    var router = (0,next_router.useRouter)();
    if (!seoTags) return /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultSeo, {});
    var title = seoTags.title, titleTag = seoTags.titleTag, description = seoTags.description, abstract = seoTags.abstract, canonical = seoTags.canonical, canonicalURL = seoTags.canonicalURL, robots = seoTags.robots;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: titleTag || title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "title",
                content: title
            }),
            robots && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: robots
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }),
            abstract && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "abstract",
                content: abstract
            }),
            canonical && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: "".concat("https://www.theknot.com").concat(router.basePath).concat(canonicalURL || router.asPath.split("?")[0])
            })
        ]
    });
};
/* harmony default export */ var components_Seo = (Seo);


/***/ }),

/***/ 92737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LW": function() { return /* binding */ trackInteraction; },
/* harmony export */   "pB": function() { return /* binding */ trackInteractionPromise; },
/* harmony export */   "tN": function() { return /* binding */ pageView; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21170);
/* harmony import */ var _tracker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30380);




var pageView = function(props) {
    if (false) {}
    (0,_tracker__WEBPACK_IMPORTED_MODULE_0__/* .initializeTracking */ .e)();
    var page = window.analytics.page;
    page && page(props);
};
function mergeBaseOptions(props) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props), {
        section: "paper"
    });
}
var trackInteraction = function(event, properties) {
    (0,_tracker__WEBPACK_IMPORTED_MODULE_0__/* .initializeTracking */ .e)();
    var track = window.analytics.track;
    var integrations = (0,_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__/* .createAnalyticsIntegrations */ .zc)();
    track && track(event, mergeBaseOptions(properties), integrations);
};
var trackInteractionPromise = function(event, properties) {
    (0,_tracker__WEBPACK_IMPORTED_MODULE_0__/* .initializeTracking */ .e)();
    var track = window.analytics.track;
    var integrations = (0,_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__/* .createAnalyticsIntegrations */ .zc)();
    var trackCallPromise = new Promise(function(resolve) {
        track && track(event, mergeBaseOptions(properties), integrations, function() {
            resolve("".concat(event, " tracked"));
        });
    });
    var timeout = new Promise(function(resolve) {
        var id = setTimeout(function() {
            clearTimeout(id);
            resolve("Timeout of 3s");
        }, 3000);
    });
    return Promise.race([
        trackCallPromise,
        timeout
    ]);
};


/***/ }),

/***/ 16774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ isWindowDefined; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99084);

var isWindowDefined = "object" !== "undefined";
var useCheckMobileScreen = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), width = ref[0], setWidth = ref[1];
    var handleWindowSizeChange = function() {
        setWidth(window.innerWidth);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        handleWindowSizeChange();
        window.addEventListener("resize", handleWindowSizeChange);
        return function() {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, []);
    return !!width && width <= 768;
};
/* harmony default export */ __webpack_exports__["Z"] = (useCheckMobileScreen);


/***/ }),

/***/ 76411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useFeatureToggle; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99084);
/* harmony import */ var _FeatureToggleContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31459);


var useFeatureToggle = function() {
    var features = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_FeatureToggleContext__WEBPACK_IMPORTED_MODULE_1__/* .FeatureToggleContext */ .zh);
    if (features === undefined) {
        throw new Error("useFeatureToggle hook must be used within a FeatureToggleProvider");
    }
    var isEnabled = function(feature) {
        return features === null || features === void 0 ? void 0 : features[feature];
    };
    return {
        features: features,
        isEnabled: isEnabled
    };
};


/***/ }),

/***/ 28378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72491);
/* harmony import */ var _xo_union_tk_component_alerts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49237);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82029);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);




var NoticeBanner = function(param) {
    var type = param.type, headline = param.headline, handleOnClose = param.handleOnClose, styleOverrides = param.styleOverrides, children = param.children, _isDisplayed = param.isDisplayed, isDisplayed = _isDisplayed === void 0 ? true : _isDisplayed;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xo_union_tk_component_alerts__WEBPACK_IMPORTED_MODULE_3__/* .InlineAlert */ .o5, {
        type: type,
        headline: headline,
        onCloseButtonClick: handleOnClose,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().noticeBanner), styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides.noticeBanner),
        visible: isDisplayed,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["default"] = (NoticeBanner);


/***/ }),

/***/ 84250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AV": function() { return /* binding */ REVIEW_ROUTE; },
/* harmony export */   "Bp": function() { return /* binding */ buildProductUrl; },
/* harmony export */   "C3": function() { return /* binding */ BRAND_ROUTES; },
/* harmony export */   "S$": function() { return /* binding */ YOUR_DRAFTS_ROUTE; },
/* harmony export */   "S7": function() { return /* binding */ CHECKOUT_ROUTE; },
/* harmony export */   "Uq": function() { return /* binding */ PRODUCT_LIST_ROUTE; },
/* harmony export */   "WP": function() { return /* binding */ CART_ROUTE; },
/* harmony export */   "e3": function() { return /* binding */ getBrandRoutes; },
/* harmony export */   "sN": function() { return /* binding */ buildCanvasPath; },
/* harmony export */   "tM": function() { return /* binding */ CONFIRMATION_ROUTE; }
/* harmony export */ });
/* unused harmony export INVITATIONS_ROUTE */
var WWRoutes;
(function(WWRoutes) {
    WWRoutes["Product"] = "p";
    WWRoutes["Products"] = "products";
    WWRoutes["ShippingOrderPolicies"] = "shipping-policies";
})(WWRoutes || (WWRoutes = {}));
var TKRoutes;
(function(TKRoutes) {
    TKRoutes["Product"] = "product";
    TKRoutes["Products"] = "products";
    TKRoutes["Canvas"] = "canvas";
    TKRoutes["Cart"] = "cart";
    TKRoutes["ReviewPage"] = "order";
    TKRoutes["ShippingOrderPolicies"] = "shipping-order-policies";
})(TKRoutes || (TKRoutes = {}));
var getBrandRoutes = function() {
    var brand = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "tk" || 0;
    switch(brand){
        case "tk":
            return TKRoutes;
        case "ww":
            return WWRoutes;
        default:
            return TKRoutes;
    }
};
var BRAND_ROUTES = getBrandRoutes();
var YOUR_DRAFTS_ROUTE = "/your-drafts";
var CART_ROUTE = "/cart";
var CHECKOUT_ROUTE = "/checkout";
var CONFIRMATION_ROUTE = "/confirmation";
var INVITATIONS_ROUTE = "/invitations";
var PRODUCT_LIST_ROUTE = "/[...slug]";
var REVIEW_ROUTE = "/order/order_item";
var buildProductUrl = function(param) {
    var slug = param.slug, variationId = param.variationId, quantity = param.quantity, parentId = param.parentId;
    var url = "/".concat(BRAND_ROUTES.Product, "/").concat(slug);
    var params = new URLSearchParams();
    variationId && params.set("v", variationId);
    quantity && params.set("q", String(quantity));
    parentId && params.set("parent_item", parentId);
    return url + (params.toString() ? "?".concat(params.toString()) : "");
};
var buildCanvasPath = function(id, destination) {
    var path = "/canvas/".concat(id);
    return destination ? "".concat(path, "?destination=").concat(destination) : path;
};


/***/ }),

/***/ 83430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72491);
/* harmony import */ var _utils_config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76806);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99084);
/* harmony import */ var _routing_externalApp__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(39313);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96645);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15317);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Link_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83593);
/* harmony import */ var _Link_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Link_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _ww_LinkWW_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27555);
/* harmony import */ var _ww_LinkWW_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_ww_LinkWW_module_scss__WEBPACK_IMPORTED_MODULE_5__);













var styles = (0,_utils_config__WEBPACK_IMPORTED_MODULE_6__/* .isTenant */ .J)("ww") ? (_ww_LinkWW_module_scss__WEBPACK_IMPORTED_MODULE_5___default()) : (_Link_module_scss__WEBPACK_IMPORTED_MODULE_4___default());
var DisplayLink = function(_param) {
    var _size = _param.size, size = _size === void 0 ? "lg" : _size, _color = _param.color, color = _color === void 0 ? "primary" : _color, disabled = _param.disabled, children = _param.children, className = _param.className, href = _param.href, isExternal = _param.isExternal, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "size",
        "color",
        "disabled",
        "children",
        "className",
        "href",
        "isExternal"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), isFetched = ref[0], setIsFetched = ref[1];
    var onHoverPrefetch = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (!isFetched && !isExternal) {
            fetch(String("".concat((href === null || href === void 0 ? void 0 : href.startsWith("http")) ? "" : _utils_helpers__WEBPACK_IMPORTED_MODULE_8__/* .basePath */ .sb).concat(href)), {
                headers: {
                    purpose: "prefetch"
                }
            }).finally(function() {
                return setIsFetched(true);
            });
        }
    }, [
        href,
        isExternal,
        isFetched
    ]);
    if (!href) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
    var anchorClassName = classnames__WEBPACK_IMPORTED_MODULE_1___default()(styles.wrapper, styles[size], styles[color], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, styles.disabled, disabled), className);
    if (isExternal) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            "data-testid": "external-link",
            href: (0,_routing_externalApp__WEBPACK_IMPORTED_MODULE_10__/* .getUrlToExternalApp */ .W)(href),
            className: anchorClassName,
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: href,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, props), {
            className: anchorClassName,
            onMouseOver: onHoverPrefetch,
            children: children
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DisplayLink);


/***/ }),

/***/ 22655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BM": function() { return /* binding */ PaperH4; },
/* harmony export */   "Sp": function() { return /* binding */ PaperH2; },
/* harmony export */   "U4": function() { return /* binding */ PaperHeroMedium; },
/* harmony export */   "eF": function() { return /* binding */ PaperEditorial; },
/* harmony export */   "iA": function() { return /* binding */ PaperHeroSmall; },
/* harmony export */   "jx": function() { return /* binding */ PaperBody2; },
/* harmony export */   "nu": function() { return /* binding */ PaperBody1; },
/* harmony export */   "s2": function() { return /* binding */ PaperH1; },
/* harmony export */   "v9": function() { return /* binding */ PaperH3; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72491);
/* harmony import */ var _xo_union_tk_ui_typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93020);
/* harmony import */ var _xo_union_tk_ui_typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33558);
/* harmony import */ var _xo_union_tk_ui_typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43786);
/* harmony import */ var _xo_union_tk_ui_typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56124);
/* harmony import */ var _utils_config__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(76806);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _typography_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30240);
/* harmony import */ var _typography_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_typography_module_scss__WEBPACK_IMPORTED_MODULE_2__);







var H1WW = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xo_union_tk_ui_typography__WEBPACK_IMPORTED_MODULE_3__.H1, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_typography_module_scss__WEBPACK_IMPORTED_MODULE_2___default().h1), props.className)
    }));
};
var H2WW = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xo_union_tk_ui_typography__WEBPACK_IMPORTED_MODULE_3__.H2, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_typography_module_scss__WEBPACK_IMPORTED_MODULE_2___default().h2), props.className)
    }));
};
var H3WW = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xo_union_tk_ui_typography__WEBPACK_IMPORTED_MODULE_3__.H3, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_typography_module_scss__WEBPACK_IMPORTED_MODULE_2___default().h3), props.className)
    }));
};
var H4WW = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xo_union_tk_ui_typography__WEBPACK_IMPORTED_MODULE_3__.H4, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_typography_module_scss__WEBPACK_IMPORTED_MODULE_2___default().h3), props.className)
    }));
};
var Body1WW = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xo_union_tk_ui_typography__WEBPACK_IMPORTED_MODULE_6__/* .Body1 */ .m, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_typography_module_scss__WEBPACK_IMPORTED_MODULE_2___default().body1), props.className)
    }));
};
var Body2WW = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xo_union_tk_ui_typography__WEBPACK_IMPORTED_MODULE_6__/* .Body2 */ .p, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_typography_module_scss__WEBPACK_IMPORTED_MODULE_2___default().body2), props.className)
    }));
};
var EditorialWW = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xo_union_tk_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_typography_module_scss__WEBPACK_IMPORTED_MODULE_2___default().editorial), props.className)
    }));
};
var HeroSmallTK = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xo_union_tk_ui_typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        size: "sm"
    }));
};
var HeroSmallWW = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xo_union_tk_ui_typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_typography_module_scss__WEBPACK_IMPORTED_MODULE_2___default().heroSmall), props.className)
    }));
};
var HeroMediumTK = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xo_union_tk_ui_typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        size: "md"
    }));
};
var HeroMediumWW = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xo_union_tk_ui_typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_typography_module_scss__WEBPACK_IMPORTED_MODULE_2___default().heroMedium), props.className)
    }));
};
var PaperH1 = (0,_utils_config__WEBPACK_IMPORTED_MODULE_9__/* .isTenant */ .J)("ww") ? H1WW : _xo_union_tk_ui_typography__WEBPACK_IMPORTED_MODULE_3__.H1;
var PaperH2 = (0,_utils_config__WEBPACK_IMPORTED_MODULE_9__/* .isTenant */ .J)("ww") ? H2WW : _xo_union_tk_ui_typography__WEBPACK_IMPORTED_MODULE_3__.H2;
var PaperH3 = (0,_utils_config__WEBPACK_IMPORTED_MODULE_9__/* .isTenant */ .J)("ww") ? H3WW : _xo_union_tk_ui_typography__WEBPACK_IMPORTED_MODULE_3__.H3;
var PaperH4 = (0,_utils_config__WEBPACK_IMPORTED_MODULE_9__/* .isTenant */ .J)("ww") ? H4WW : _xo_union_tk_ui_typography__WEBPACK_IMPORTED_MODULE_3__.H4;
var PaperBody1 = (0,_utils_config__WEBPACK_IMPORTED_MODULE_9__/* .isTenant */ .J)("ww") ? Body1WW : _xo_union_tk_ui_typography__WEBPACK_IMPORTED_MODULE_6__/* .Body1 */ .m;
var PaperBody2 = (0,_utils_config__WEBPACK_IMPORTED_MODULE_9__/* .isTenant */ .J)("ww") ? Body2WW : _xo_union_tk_ui_typography__WEBPACK_IMPORTED_MODULE_6__/* .Body2 */ .p;
var PaperEditorial = (0,_utils_config__WEBPACK_IMPORTED_MODULE_9__/* .isTenant */ .J)("ww") ? EditorialWW : _xo_union_tk_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z;
var PaperHeroSmall = (0,_utils_config__WEBPACK_IMPORTED_MODULE_9__/* .isTenant */ .J)("ww") ? HeroSmallWW : HeroSmallTK;
var PaperHeroMedium = (0,_utils_config__WEBPACK_IMPORTED_MODULE_9__/* .isTenant */ .J)("ww") ? HeroMediumWW : HeroMediumTK;


/***/ })

}]);